/* Auto-generated from public/editor/resources/google-fonts.json — do not edit by hand */
export var GOOGLE_FONTS_CATALOG = [{
  "name": "ABeeZee",
  "category": "sans-serif",
  "value": "'ABeeZee', sans-serif"
}, {
  "name": "Abel",
  "category": "sans-serif",
  "value": "'Abel', sans-serif"
}, {
  "name": "Abhaya Libre",
  "category": "serif",
  "value": "'Abhaya Libre', serif"
}, {
  "name": "Abril Fatface",
  "category": "display",
  "value": "'Abril Fatface', sans-serif"
}, {
  "name": "Aclonica",
  "category": "sans-serif",
  "value": "'Aclonica', sans-serif"
}, {
  "name": "Acme",
  "category": "sans-serif",
  "value": "'Acme', sans-serif"
}, {
  "name": "Actor",
  "category": "sans-serif",
  "value": "'Actor', sans-serif"
}, {
  "name": "Adamina",
  "category": "serif",
  "value": "'Adamina', serif"
}, {
  "name": "Advent Pro",
  "category": "sans-serif",
  "value": "'Advent Pro', sans-serif"
}, {
  "name": "Aguafina Script",
  "category": "handwriting",
  "value": "'Aguafina Script', cursive"
}, {
  "name": "Akaya Kanadaka",
  "category": "display",
  "value": "'Akaya Kanadaka', sans-serif"
}, {
  "name": "Akaya Telivigala",
  "category": "display",
  "value": "'Akaya Telivigala', sans-serif"
}, {
  "name": "Akronim",
  "category": "display",
  "value": "'Akronim', sans-serif"
}, {
  "name": "Aladin",
  "category": "handwriting",
  "value": "'Aladin', cursive"
}, {
  "name": "Alata",
  "category": "sans-serif",
  "value": "'Alata', sans-serif"
}, {
  "name": "Alatsi",
  "category": "sans-serif",
  "value": "'Alatsi', sans-serif"
}, {
  "name": "Aldrich",
  "category": "sans-serif",
  "value": "'Aldrich', sans-serif"
}, {
  "name": "Alef",
  "category": "sans-serif",
  "value": "'Alef', sans-serif"
}, {
  "name": "Alegreya",
  "category": "serif",
  "value": "'Alegreya', serif"
}, {
  "name": "Alegreya Sans",
  "category": "sans-serif",
  "value": "'Alegreya Sans', sans-serif"
}, {
  "name": "Alegreya Sans SC",
  "category": "sans-serif",
  "value": "'Alegreya Sans SC', sans-serif"
}, {
  "name": "Alegreya SC",
  "category": "serif",
  "value": "'Alegreya SC', serif"
}, {
  "name": "Aleo",
  "category": "serif",
  "value": "'Aleo', serif"
}, {
  "name": "Alex Brush",
  "category": "handwriting",
  "value": "'Alex Brush', cursive"
}, {
  "name": "Alfa Slab One",
  "category": "display",
  "value": "'Alfa Slab One', sans-serif"
}, {
  "name": "Alice",
  "category": "serif",
  "value": "'Alice', serif"
}, {
  "name": "Alike",
  "category": "serif",
  "value": "'Alike', serif"
}, {
  "name": "Alike Angular",
  "category": "serif",
  "value": "'Alike Angular', serif"
}, {
  "name": "Allan",
  "category": "display",
  "value": "'Allan', sans-serif"
}, {
  "name": "Allerta",
  "category": "sans-serif",
  "value": "'Allerta', sans-serif"
}, {
  "name": "Allerta Stencil",
  "category": "sans-serif",
  "value": "'Allerta Stencil', sans-serif"
}, {
  "name": "Allison",
  "category": "handwriting",
  "value": "'Allison', cursive"
}, {
  "name": "Allura",
  "category": "handwriting",
  "value": "'Allura', cursive"
}, {
  "name": "Almarai",
  "category": "sans-serif",
  "value": "'Almarai', sans-serif"
}, {
  "name": "Almendra",
  "category": "serif",
  "value": "'Almendra', serif"
}, {
  "name": "Almendra Display",
  "category": "display",
  "value": "'Almendra Display', sans-serif"
}, {
  "name": "Almendra SC",
  "category": "serif",
  "value": "'Almendra SC', serif"
}, {
  "name": "Alumni Sans",
  "category": "sans-serif",
  "value": "'Alumni Sans', sans-serif"
}, {
  "name": "Amarante",
  "category": "display",
  "value": "'Amarante', sans-serif"
}, {
  "name": "Amaranth",
  "category": "sans-serif",
  "value": "'Amaranth', sans-serif"
}, {
  "name": "Amatic SC",
  "category": "handwriting",
  "value": "'Amatic SC', cursive"
}, {
  "name": "Amethysta",
  "category": "serif",
  "value": "'Amethysta', serif"
}, {
  "name": "Amiko",
  "category": "sans-serif",
  "value": "'Amiko', sans-serif"
}, {
  "name": "Amiri",
  "category": "serif",
  "value": "'Amiri', serif"
}, {
  "name": "Amita",
  "category": "handwriting",
  "value": "'Amita', cursive"
}, {
  "name": "Anaheim",
  "category": "sans-serif",
  "value": "'Anaheim', sans-serif"
}, {
  "name": "Andada Pro",
  "category": "serif",
  "value": "'Andada Pro', serif"
}, {
  "name": "Andika",
  "category": "sans-serif",
  "value": "'Andika', sans-serif"
}, {
  "name": "Andika New Basic",
  "category": "sans-serif",
  "value": "'Andika New Basic', sans-serif"
}, {
  "name": "Angkor",
  "category": "display",
  "value": "'Angkor', sans-serif"
}, {
  "name": "Annie Use Your Telescope",
  "category": "handwriting",
  "value": "'Annie Use Your Telescope', cursive"
}, {
  "name": "Anonymous Pro",
  "category": "monospace",
  "value": "'Anonymous Pro', monospace"
}, {
  "name": "Antic",
  "category": "sans-serif",
  "value": "'Antic', sans-serif"
}, {
  "name": "Antic Didone",
  "category": "serif",
  "value": "'Antic Didone', serif"
}, {
  "name": "Antic Slab",
  "category": "serif",
  "value": "'Antic Slab', serif"
}, {
  "name": "Anton",
  "category": "sans-serif",
  "value": "'Anton', sans-serif"
}, {
  "name": "Antonio",
  "category": "sans-serif",
  "value": "'Antonio', sans-serif"
}, {
  "name": "Arapey",
  "category": "serif",
  "value": "'Arapey', serif"
}, {
  "name": "Arbutus",
  "category": "display",
  "value": "'Arbutus', sans-serif"
}, {
  "name": "Arbutus Slab",
  "category": "serif",
  "value": "'Arbutus Slab', serif"
}, {
  "name": "Architects Daughter",
  "category": "handwriting",
  "value": "'Architects Daughter', cursive"
}, {
  "name": "Archivo",
  "category": "sans-serif",
  "value": "'Archivo', sans-serif"
}, {
  "name": "Archivo Black",
  "category": "sans-serif",
  "value": "'Archivo Black', sans-serif"
}, {
  "name": "Archivo Narrow",
  "category": "sans-serif",
  "value": "'Archivo Narrow', sans-serif"
}, {
  "name": "Are You Serious",
  "category": "handwriting",
  "value": "'Are You Serious', cursive"
}, {
  "name": "Aref Ruqaa",
  "category": "serif",
  "value": "'Aref Ruqaa', serif"
}, {
  "name": "Arima Madurai",
  "category": "display",
  "value": "'Arima Madurai', sans-serif"
}, {
  "name": "Arimo",
  "category": "sans-serif",
  "value": "'Arimo', sans-serif"
}, {
  "name": "Arizonia",
  "category": "handwriting",
  "value": "'Arizonia', cursive"
}, {
  "name": "Armata",
  "category": "sans-serif",
  "value": "'Armata', sans-serif"
}, {
  "name": "Arsenal",
  "category": "sans-serif",
  "value": "'Arsenal', sans-serif"
}, {
  "name": "Artifika",
  "category": "serif",
  "value": "'Artifika', serif"
}, {
  "name": "Arvo",
  "category": "serif",
  "value": "'Arvo', serif"
}, {
  "name": "Arya",
  "category": "sans-serif",
  "value": "'Arya', sans-serif"
}, {
  "name": "Asap",
  "category": "sans-serif",
  "value": "'Asap', sans-serif"
}, {
  "name": "Asap Condensed",
  "category": "sans-serif",
  "value": "'Asap Condensed', sans-serif"
}, {
  "name": "Asar",
  "category": "serif",
  "value": "'Asar', serif"
}, {
  "name": "Asset",
  "category": "display",
  "value": "'Asset', sans-serif"
}, {
  "name": "Assistant",
  "category": "sans-serif",
  "value": "'Assistant', sans-serif"
}, {
  "name": "Astloch",
  "category": "display",
  "value": "'Astloch', sans-serif"
}, {
  "name": "Asul",
  "category": "sans-serif",
  "value": "'Asul', sans-serif"
}, {
  "name": "Athiti",
  "category": "sans-serif",
  "value": "'Athiti', sans-serif"
}, {
  "name": "Atkinson Hyperlegible",
  "category": "sans-serif",
  "value": "'Atkinson Hyperlegible', sans-serif"
}, {
  "name": "Atma",
  "category": "display",
  "value": "'Atma', sans-serif"
}, {
  "name": "Atomic Age",
  "category": "display",
  "value": "'Atomic Age', sans-serif"
}, {
  "name": "Aubrey",
  "category": "display",
  "value": "'Aubrey', sans-serif"
}, {
  "name": "Audiowide",
  "category": "display",
  "value": "'Audiowide', sans-serif"
}, {
  "name": "Autour One",
  "category": "display",
  "value": "'Autour One', sans-serif"
}, {
  "name": "Average",
  "category": "serif",
  "value": "'Average', serif"
}, {
  "name": "Average Sans",
  "category": "sans-serif",
  "value": "'Average Sans', sans-serif"
}, {
  "name": "Averia Gruesa Libre",
  "category": "display",
  "value": "'Averia Gruesa Libre', sans-serif"
}, {
  "name": "Averia Libre",
  "category": "display",
  "value": "'Averia Libre', sans-serif"
}, {
  "name": "Averia Sans Libre",
  "category": "display",
  "value": "'Averia Sans Libre', sans-serif"
}, {
  "name": "Averia Serif Libre",
  "category": "display",
  "value": "'Averia Serif Libre', sans-serif"
}, {
  "name": "Azeret Mono",
  "category": "monospace",
  "value": "'Azeret Mono', monospace"
}, {
  "name": "B612",
  "category": "sans-serif",
  "value": "'B612', sans-serif"
}, {
  "name": "B612 Mono",
  "category": "monospace",
  "value": "'B612 Mono', monospace"
}, {
  "name": "Bad Script",
  "category": "handwriting",
  "value": "'Bad Script', cursive"
}, {
  "name": "Bahiana",
  "category": "display",
  "value": "'Bahiana', sans-serif"
}, {
  "name": "Bahianita",
  "category": "display",
  "value": "'Bahianita', sans-serif"
}, {
  "name": "Bai Jamjuree",
  "category": "sans-serif",
  "value": "'Bai Jamjuree', sans-serif"
}, {
  "name": "Ballet",
  "category": "handwriting",
  "value": "'Ballet', cursive"
}, {
  "name": "Baloo 2",
  "category": "display",
  "value": "'Baloo 2', sans-serif"
}, {
  "name": "Baloo Bhai 2",
  "category": "display",
  "value": "'Baloo Bhai 2', sans-serif"
}, {
  "name": "Baloo Bhaina 2",
  "category": "display",
  "value": "'Baloo Bhaina 2', sans-serif"
}, {
  "name": "Baloo Chettan 2",
  "category": "display",
  "value": "'Baloo Chettan 2', sans-serif"
}, {
  "name": "Baloo Da 2",
  "category": "display",
  "value": "'Baloo Da 2', sans-serif"
}, {
  "name": "Baloo Paaji 2",
  "category": "display",
  "value": "'Baloo Paaji 2', sans-serif"
}, {
  "name": "Baloo Tamma 2",
  "category": "display",
  "value": "'Baloo Tamma 2', sans-serif"
}, {
  "name": "Baloo Tammudu 2",
  "category": "display",
  "value": "'Baloo Tammudu 2', sans-serif"
}, {
  "name": "Baloo Thambi 2",
  "category": "display",
  "value": "'Baloo Thambi 2', sans-serif"
}, {
  "name": "Balsamiq Sans",
  "category": "display",
  "value": "'Balsamiq Sans', sans-serif"
}, {
  "name": "Balthazar",
  "category": "serif",
  "value": "'Balthazar', serif"
}, {
  "name": "Bangers",
  "category": "display",
  "value": "'Bangers', sans-serif"
}, {
  "name": "Barlow",
  "category": "sans-serif",
  "value": "'Barlow', sans-serif"
}, {
  "name": "Barlow Condensed",
  "category": "sans-serif",
  "value": "'Barlow Condensed', sans-serif"
}, {
  "name": "Barlow Semi Condensed",
  "category": "sans-serif",
  "value": "'Barlow Semi Condensed', sans-serif"
}, {
  "name": "Barriecito",
  "category": "display",
  "value": "'Barriecito', sans-serif"
}, {
  "name": "Barrio",
  "category": "display",
  "value": "'Barrio', sans-serif"
}, {
  "name": "Basic",
  "category": "sans-serif",
  "value": "'Basic', sans-serif"
}, {
  "name": "Baskervville",
  "category": "serif",
  "value": "'Baskervville', serif"
}, {
  "name": "Battambang",
  "category": "display",
  "value": "'Battambang', sans-serif"
}, {
  "name": "Baumans",
  "category": "display",
  "value": "'Baumans', sans-serif"
}, {
  "name": "Bayon",
  "category": "sans-serif",
  "value": "'Bayon', sans-serif"
}, {
  "name": "Be Vietnam",
  "category": "sans-serif",
  "value": "'Be Vietnam', sans-serif"
}, {
  "name": "Be Vietnam Pro",
  "category": "sans-serif",
  "value": "'Be Vietnam Pro', sans-serif"
}, {
  "name": "Bebas Neue",
  "category": "display",
  "value": "'Bebas Neue', sans-serif"
}, {
  "name": "Belgrano",
  "category": "serif",
  "value": "'Belgrano', serif"
}, {
  "name": "Bellefair",
  "category": "serif",
  "value": "'Bellefair', serif"
}, {
  "name": "Belleza",
  "category": "sans-serif",
  "value": "'Belleza', sans-serif"
}, {
  "name": "Bellota",
  "category": "display",
  "value": "'Bellota', sans-serif"
}, {
  "name": "Bellota Text",
  "category": "display",
  "value": "'Bellota Text', sans-serif"
}, {
  "name": "BenchNine",
  "category": "sans-serif",
  "value": "'BenchNine', sans-serif"
}, {
  "name": "Benne",
  "category": "serif",
  "value": "'Benne', serif"
}, {
  "name": "Bentham",
  "category": "serif",
  "value": "'Bentham', serif"
}, {
  "name": "Berkshire Swash",
  "category": "handwriting",
  "value": "'Berkshire Swash', cursive"
}, {
  "name": "Besley",
  "category": "serif",
  "value": "'Besley', serif"
}, {
  "name": "Beth Ellen",
  "category": "handwriting",
  "value": "'Beth Ellen', cursive"
}, {
  "name": "Bevan",
  "category": "display",
  "value": "'Bevan', sans-serif"
}, {
  "name": "Big Shoulders Display",
  "category": "display",
  "value": "'Big Shoulders Display', sans-serif"
}, {
  "name": "Big Shoulders Inline Display",
  "category": "display",
  "value": "'Big Shoulders Inline Display', sans-serif"
}, {
  "name": "Big Shoulders Inline Text",
  "category": "display",
  "value": "'Big Shoulders Inline Text', sans-serif"
}, {
  "name": "Big Shoulders Stencil Display",
  "category": "display",
  "value": "'Big Shoulders Stencil Display', sans-serif"
}, {
  "name": "Big Shoulders Stencil Text",
  "category": "display",
  "value": "'Big Shoulders Stencil Text', sans-serif"
}, {
  "name": "Big Shoulders Text",
  "category": "display",
  "value": "'Big Shoulders Text', sans-serif"
}, {
  "name": "Bigelow Rules",
  "category": "display",
  "value": "'Bigelow Rules', sans-serif"
}, {
  "name": "Bigshot One",
  "category": "display",
  "value": "'Bigshot One', sans-serif"
}, {
  "name": "Bilbo",
  "category": "handwriting",
  "value": "'Bilbo', cursive"
}, {
  "name": "Bilbo Swash Caps",
  "category": "handwriting",
  "value": "'Bilbo Swash Caps', cursive"
}, {
  "name": "BioRhyme",
  "category": "serif",
  "value": "'BioRhyme', serif"
}, {
  "name": "BioRhyme Expanded",
  "category": "serif",
  "value": "'BioRhyme Expanded', serif"
}, {
  "name": "Birthstone",
  "category": "handwriting",
  "value": "'Birthstone', cursive"
}, {
  "name": "Birthstone Bounce",
  "category": "handwriting",
  "value": "'Birthstone Bounce', cursive"
}, {
  "name": "Biryani",
  "category": "sans-serif",
  "value": "'Biryani', sans-serif"
}, {
  "name": "Bitter",
  "category": "serif",
  "value": "'Bitter', serif"
}, {
  "name": "Black And White Picture",
  "category": "sans-serif",
  "value": "'Black And White Picture', sans-serif"
}, {
  "name": "Black Han Sans",
  "category": "sans-serif",
  "value": "'Black Han Sans', sans-serif"
}, {
  "name": "Black Ops One",
  "category": "display",
  "value": "'Black Ops One', sans-serif"
}, {
  "name": "Blinker",
  "category": "sans-serif",
  "value": "'Blinker', sans-serif"
}, {
  "name": "Bodoni Moda",
  "category": "serif",
  "value": "'Bodoni Moda', serif"
}, {
  "name": "Bokor",
  "category": "display",
  "value": "'Bokor', sans-serif"
}, {
  "name": "Bona Nova",
  "category": "serif",
  "value": "'Bona Nova', serif"
}, {
  "name": "Bonbon",
  "category": "handwriting",
  "value": "'Bonbon', cursive"
}, {
  "name": "Bonheur Royale",
  "category": "handwriting",
  "value": "'Bonheur Royale', cursive"
}, {
  "name": "Boogaloo",
  "category": "display",
  "value": "'Boogaloo', sans-serif"
}, {
  "name": "Bowlby One",
  "category": "display",
  "value": "'Bowlby One', sans-serif"
}, {
  "name": "Bowlby One SC",
  "category": "display",
  "value": "'Bowlby One SC', sans-serif"
}, {
  "name": "Brawler",
  "category": "serif",
  "value": "'Brawler', serif"
}, {
  "name": "Bree Serif",
  "category": "serif",
  "value": "'Bree Serif', serif"
}, {
  "name": "Brygada 1918",
  "category": "serif",
  "value": "'Brygada 1918', serif"
}, {
  "name": "Bubblegum Sans",
  "category": "display",
  "value": "'Bubblegum Sans', sans-serif"
}, {
  "name": "Bubbler One",
  "category": "sans-serif",
  "value": "'Bubbler One', sans-serif"
}, {
  "name": "Buda",
  "category": "display",
  "value": "'Buda', sans-serif"
}, {
  "name": "Buenard",
  "category": "serif",
  "value": "'Buenard', serif"
}, {
  "name": "Bungee",
  "category": "display",
  "value": "'Bungee', sans-serif"
}, {
  "name": "Bungee Hairline",
  "category": "display",
  "value": "'Bungee Hairline', sans-serif"
}, {
  "name": "Bungee Inline",
  "category": "display",
  "value": "'Bungee Inline', sans-serif"
}, {
  "name": "Bungee Outline",
  "category": "display",
  "value": "'Bungee Outline', sans-serif"
}, {
  "name": "Bungee Shade",
  "category": "display",
  "value": "'Bungee Shade', sans-serif"
}, {
  "name": "Butcherman",
  "category": "display",
  "value": "'Butcherman', sans-serif"
}, {
  "name": "Butterfly Kids",
  "category": "handwriting",
  "value": "'Butterfly Kids', cursive"
}, {
  "name": "Cabin",
  "category": "sans-serif",
  "value": "'Cabin', sans-serif"
}, {
  "name": "Cabin Condensed",
  "category": "sans-serif",
  "value": "'Cabin Condensed', sans-serif"
}, {
  "name": "Cabin Sketch",
  "category": "display",
  "value": "'Cabin Sketch', sans-serif"
}, {
  "name": "Caesar Dressing",
  "category": "display",
  "value": "'Caesar Dressing', sans-serif"
}, {
  "name": "Cagliostro",
  "category": "sans-serif",
  "value": "'Cagliostro', sans-serif"
}, {
  "name": "Cairo",
  "category": "sans-serif",
  "value": "'Cairo', sans-serif"
}, {
  "name": "Caladea",
  "category": "serif",
  "value": "'Caladea', serif"
}, {
  "name": "Calistoga",
  "category": "display",
  "value": "'Calistoga', sans-serif"
}, {
  "name": "Calligraffitti",
  "category": "handwriting",
  "value": "'Calligraffitti', cursive"
}, {
  "name": "Cambay",
  "category": "sans-serif",
  "value": "'Cambay', sans-serif"
}, {
  "name": "Cambo",
  "category": "serif",
  "value": "'Cambo', serif"
}, {
  "name": "Candal",
  "category": "sans-serif",
  "value": "'Candal', sans-serif"
}, {
  "name": "Cantarell",
  "category": "sans-serif",
  "value": "'Cantarell', sans-serif"
}, {
  "name": "Cantata One",
  "category": "serif",
  "value": "'Cantata One', serif"
}, {
  "name": "Cantora One",
  "category": "sans-serif",
  "value": "'Cantora One', sans-serif"
}, {
  "name": "Capriola",
  "category": "sans-serif",
  "value": "'Capriola', sans-serif"
}, {
  "name": "Caramel",
  "category": "handwriting",
  "value": "'Caramel', cursive"
}, {
  "name": "Carattere",
  "category": "handwriting",
  "value": "'Carattere', cursive"
}, {
  "name": "Cardo",
  "category": "serif",
  "value": "'Cardo', serif"
}, {
  "name": "Carme",
  "category": "sans-serif",
  "value": "'Carme', sans-serif"
}, {
  "name": "Carrois Gothic",
  "category": "sans-serif",
  "value": "'Carrois Gothic', sans-serif"
}, {
  "name": "Carrois Gothic SC",
  "category": "sans-serif",
  "value": "'Carrois Gothic SC', sans-serif"
}, {
  "name": "Carter One",
  "category": "display",
  "value": "'Carter One', sans-serif"
}, {
  "name": "Castoro",
  "category": "serif",
  "value": "'Castoro', serif"
}, {
  "name": "Catamaran",
  "category": "sans-serif",
  "value": "'Catamaran', sans-serif"
}, {
  "name": "Caudex",
  "category": "serif",
  "value": "'Caudex', serif"
}, {
  "name": "Caveat",
  "category": "handwriting",
  "value": "'Caveat', cursive"
}, {
  "name": "Caveat Brush",
  "category": "handwriting",
  "value": "'Caveat Brush', cursive"
}, {
  "name": "Cedarville Cursive",
  "category": "handwriting",
  "value": "'Cedarville Cursive', cursive"
}, {
  "name": "Ceviche One",
  "category": "display",
  "value": "'Ceviche One', sans-serif"
}, {
  "name": "Chakra Petch",
  "category": "sans-serif",
  "value": "'Chakra Petch', sans-serif"
}, {
  "name": "Changa",
  "category": "sans-serif",
  "value": "'Changa', sans-serif"
}, {
  "name": "Changa One",
  "category": "display",
  "value": "'Changa One', sans-serif"
}, {
  "name": "Chango",
  "category": "display",
  "value": "'Chango', sans-serif"
}, {
  "name": "Charm",
  "category": "handwriting",
  "value": "'Charm', cursive"
}, {
  "name": "Charmonman",
  "category": "handwriting",
  "value": "'Charmonman', cursive"
}, {
  "name": "Chathura",
  "category": "sans-serif",
  "value": "'Chathura', sans-serif"
}, {
  "name": "Chau Philomene One",
  "category": "sans-serif",
  "value": "'Chau Philomene One', sans-serif"
}, {
  "name": "Chela One",
  "category": "display",
  "value": "'Chela One', sans-serif"
}, {
  "name": "Chelsea Market",
  "category": "display",
  "value": "'Chelsea Market', sans-serif"
}, {
  "name": "Chenla",
  "category": "display",
  "value": "'Chenla', sans-serif"
}, {
  "name": "Cherish",
  "category": "handwriting",
  "value": "'Cherish', cursive"
}, {
  "name": "Cherry Cream Soda",
  "category": "display",
  "value": "'Cherry Cream Soda', sans-serif"
}, {
  "name": "Cherry Swash",
  "category": "display",
  "value": "'Cherry Swash', sans-serif"
}, {
  "name": "Chewy",
  "category": "display",
  "value": "'Chewy', sans-serif"
}, {
  "name": "Chicle",
  "category": "display",
  "value": "'Chicle', sans-serif"
}, {
  "name": "Chilanka",
  "category": "handwriting",
  "value": "'Chilanka', cursive"
}, {
  "name": "Chivo",
  "category": "sans-serif",
  "value": "'Chivo', sans-serif"
}, {
  "name": "Chonburi",
  "category": "display",
  "value": "'Chonburi', sans-serif"
}, {
  "name": "Cinzel",
  "category": "serif",
  "value": "'Cinzel', serif"
}, {
  "name": "Cinzel Decorative",
  "category": "display",
  "value": "'Cinzel Decorative', sans-serif"
}, {
  "name": "Clicker Script",
  "category": "handwriting",
  "value": "'Clicker Script', cursive"
}, {
  "name": "Coda",
  "category": "display",
  "value": "'Coda', sans-serif"
}, {
  "name": "Coda Caption",
  "category": "sans-serif",
  "value": "'Coda Caption', sans-serif"
}, {
  "name": "Codystar",
  "category": "display",
  "value": "'Codystar', sans-serif"
}, {
  "name": "Coiny",
  "category": "display",
  "value": "'Coiny', sans-serif"
}, {
  "name": "Combo",
  "category": "display",
  "value": "'Combo', sans-serif"
}, {
  "name": "Comfortaa",
  "category": "display",
  "value": "'Comfortaa', sans-serif"
}, {
  "name": "Comic Neue",
  "category": "handwriting",
  "value": "'Comic Neue', cursive"
}, {
  "name": "Coming Soon",
  "category": "handwriting",
  "value": "'Coming Soon', cursive"
}, {
  "name": "Commissioner",
  "category": "sans-serif",
  "value": "'Commissioner', sans-serif"
}, {
  "name": "Concert One",
  "category": "display",
  "value": "'Concert One', sans-serif"
}, {
  "name": "Condiment",
  "category": "handwriting",
  "value": "'Condiment', cursive"
}, {
  "name": "Content",
  "category": "display",
  "value": "'Content', sans-serif"
}, {
  "name": "Contrail One",
  "category": "display",
  "value": "'Contrail One', sans-serif"
}, {
  "name": "Convergence",
  "category": "sans-serif",
  "value": "'Convergence', sans-serif"
}, {
  "name": "Cookie",
  "category": "handwriting",
  "value": "'Cookie', cursive"
}, {
  "name": "Copse",
  "category": "serif",
  "value": "'Copse', serif"
}, {
  "name": "Corben",
  "category": "display",
  "value": "'Corben', sans-serif"
}, {
  "name": "Cormorant",
  "category": "serif",
  "value": "'Cormorant', serif"
}, {
  "name": "Cormorant Garamond",
  "category": "serif",
  "value": "'Cormorant Garamond', serif"
}, {
  "name": "Cormorant Infant",
  "category": "serif",
  "value": "'Cormorant Infant', serif"
}, {
  "name": "Cormorant SC",
  "category": "serif",
  "value": "'Cormorant SC', serif"
}, {
  "name": "Cormorant Unicase",
  "category": "serif",
  "value": "'Cormorant Unicase', serif"
}, {
  "name": "Cormorant Upright",
  "category": "serif",
  "value": "'Cormorant Upright', serif"
}, {
  "name": "Courgette",
  "category": "handwriting",
  "value": "'Courgette', cursive"
}, {
  "name": "Courier Prime",
  "category": "monospace",
  "value": "'Courier Prime', monospace"
}, {
  "name": "Cousine",
  "category": "monospace",
  "value": "'Cousine', monospace"
}, {
  "name": "Coustard",
  "category": "serif",
  "value": "'Coustard', serif"
}, {
  "name": "Covered By Your Grace",
  "category": "handwriting",
  "value": "'Covered By Your Grace', cursive"
}, {
  "name": "Crafty Girls",
  "category": "handwriting",
  "value": "'Crafty Girls', cursive"
}, {
  "name": "Creepster",
  "category": "display",
  "value": "'Creepster', sans-serif"
}, {
  "name": "Crete Round",
  "category": "serif",
  "value": "'Crete Round', serif"
}, {
  "name": "Crimson Pro",
  "category": "serif",
  "value": "'Crimson Pro', serif"
}, {
  "name": "Crimson Text",
  "category": "serif",
  "value": "'Crimson Text', serif"
}, {
  "name": "Croissant One",
  "category": "display",
  "value": "'Croissant One', sans-serif"
}, {
  "name": "Crushed",
  "category": "display",
  "value": "'Crushed', sans-serif"
}, {
  "name": "Cuprum",
  "category": "sans-serif",
  "value": "'Cuprum', sans-serif"
}, {
  "name": "Cute Font",
  "category": "display",
  "value": "'Cute Font', sans-serif"
}, {
  "name": "Cutive",
  "category": "serif",
  "value": "'Cutive', serif"
}, {
  "name": "Cutive Mono",
  "category": "monospace",
  "value": "'Cutive Mono', monospace"
}, {
  "name": "Damion",
  "category": "handwriting",
  "value": "'Damion', cursive"
}, {
  "name": "Dancing Script",
  "category": "handwriting",
  "value": "'Dancing Script', cursive"
}, {
  "name": "Dangrek",
  "category": "display",
  "value": "'Dangrek', sans-serif"
}, {
  "name": "Darker Grotesque",
  "category": "sans-serif",
  "value": "'Darker Grotesque', sans-serif"
}, {
  "name": "David Libre",
  "category": "serif",
  "value": "'David Libre', serif"
}, {
  "name": "Dawning of a New Day",
  "category": "handwriting",
  "value": "'Dawning of a New Day', cursive"
}, {
  "name": "Days One",
  "category": "sans-serif",
  "value": "'Days One', sans-serif"
}, {
  "name": "Dekko",
  "category": "handwriting",
  "value": "'Dekko', cursive"
}, {
  "name": "Dela Gothic One",
  "category": "display",
  "value": "'Dela Gothic One', sans-serif"
}, {
  "name": "Delius",
  "category": "handwriting",
  "value": "'Delius', cursive"
}, {
  "name": "Delius Swash Caps",
  "category": "handwriting",
  "value": "'Delius Swash Caps', cursive"
}, {
  "name": "Delius Unicase",
  "category": "handwriting",
  "value": "'Delius Unicase', cursive"
}, {
  "name": "Della Respira",
  "category": "serif",
  "value": "'Della Respira', serif"
}, {
  "name": "Denk One",
  "category": "sans-serif",
  "value": "'Denk One', sans-serif"
}, {
  "name": "Devonshire",
  "category": "handwriting",
  "value": "'Devonshire', cursive"
}, {
  "name": "Dhurjati",
  "category": "sans-serif",
  "value": "'Dhurjati', sans-serif"
}, {
  "name": "Didact Gothic",
  "category": "sans-serif",
  "value": "'Didact Gothic', sans-serif"
}, {
  "name": "Diplomata",
  "category": "display",
  "value": "'Diplomata', sans-serif"
}, {
  "name": "Diplomata SC",
  "category": "display",
  "value": "'Diplomata SC', sans-serif"
}, {
  "name": "DM Mono",
  "category": "monospace",
  "value": "'DM Mono', monospace"
}, {
  "name": "DM Sans",
  "category": "sans-serif",
  "value": "'DM Sans', sans-serif"
}, {
  "name": "DM Serif Display",
  "category": "serif",
  "value": "'DM Serif Display', serif"
}, {
  "name": "DM Serif Text",
  "category": "serif",
  "value": "'DM Serif Text', serif"
}, {
  "name": "Do Hyeon",
  "category": "sans-serif",
  "value": "'Do Hyeon', sans-serif"
}, {
  "name": "Dokdo",
  "category": "handwriting",
  "value": "'Dokdo', cursive"
}, {
  "name": "Domine",
  "category": "serif",
  "value": "'Domine', serif"
}, {
  "name": "Donegal One",
  "category": "serif",
  "value": "'Donegal One', serif"
}, {
  "name": "Doppio One",
  "category": "sans-serif",
  "value": "'Doppio One', sans-serif"
}, {
  "name": "Dorsa",
  "category": "sans-serif",
  "value": "'Dorsa', sans-serif"
}, {
  "name": "Dosis",
  "category": "sans-serif",
  "value": "'Dosis', sans-serif"
}, {
  "name": "DotGothic16",
  "category": "sans-serif",
  "value": "'DotGothic16', sans-serif"
}, {
  "name": "Dr Sugiyama",
  "category": "handwriting",
  "value": "'Dr Sugiyama', cursive"
}, {
  "name": "Duru Sans",
  "category": "sans-serif",
  "value": "'Duru Sans', sans-serif"
}, {
  "name": "Dynalight",
  "category": "display",
  "value": "'Dynalight', sans-serif"
}, {
  "name": "Eagle Lake",
  "category": "handwriting",
  "value": "'Eagle Lake', cursive"
}, {
  "name": "East Sea Dokdo",
  "category": "handwriting",
  "value": "'East Sea Dokdo', cursive"
}, {
  "name": "Eater",
  "category": "display",
  "value": "'Eater', sans-serif"
}, {
  "name": "EB Garamond",
  "category": "serif",
  "value": "'EB Garamond', serif"
}, {
  "name": "Economica",
  "category": "sans-serif",
  "value": "'Economica', sans-serif"
}, {
  "name": "Eczar",
  "category": "serif",
  "value": "'Eczar', serif"
}, {
  "name": "El Messiri",
  "category": "sans-serif",
  "value": "'El Messiri', sans-serif"
}, {
  "name": "Electrolize",
  "category": "sans-serif",
  "value": "'Electrolize', sans-serif"
}, {
  "name": "Elsie",
  "category": "display",
  "value": "'Elsie', sans-serif"
}, {
  "name": "Elsie Swash Caps",
  "category": "display",
  "value": "'Elsie Swash Caps', sans-serif"
}, {
  "name": "Emblema One",
  "category": "display",
  "value": "'Emblema One', sans-serif"
}, {
  "name": "Emilys Candy",
  "category": "display",
  "value": "'Emilys Candy', sans-serif"
}, {
  "name": "Encode Sans",
  "category": "sans-serif",
  "value": "'Encode Sans', sans-serif"
}, {
  "name": "Encode Sans Condensed",
  "category": "sans-serif",
  "value": "'Encode Sans Condensed', sans-serif"
}, {
  "name": "Encode Sans Expanded",
  "category": "sans-serif",
  "value": "'Encode Sans Expanded', sans-serif"
}, {
  "name": "Encode Sans SC",
  "category": "sans-serif",
  "value": "'Encode Sans SC', sans-serif"
}, {
  "name": "Encode Sans Semi Condensed",
  "category": "sans-serif",
  "value": "'Encode Sans Semi Condensed', sans-serif"
}, {
  "name": "Encode Sans Semi Expanded",
  "category": "sans-serif",
  "value": "'Encode Sans Semi Expanded', sans-serif"
}, {
  "name": "Engagement",
  "category": "handwriting",
  "value": "'Engagement', cursive"
}, {
  "name": "Englebert",
  "category": "sans-serif",
  "value": "'Englebert', sans-serif"
}, {
  "name": "Enriqueta",
  "category": "serif",
  "value": "'Enriqueta', serif"
}, {
  "name": "Ephesis",
  "category": "handwriting",
  "value": "'Ephesis', cursive"
}, {
  "name": "Epilogue",
  "category": "sans-serif",
  "value": "'Epilogue', sans-serif"
}, {
  "name": "Erica One",
  "category": "display",
  "value": "'Erica One', sans-serif"
}, {
  "name": "Esteban",
  "category": "serif",
  "value": "'Esteban', serif"
}, {
  "name": "Euphoria Script",
  "category": "handwriting",
  "value": "'Euphoria Script', cursive"
}, {
  "name": "Ewert",
  "category": "display",
  "value": "'Ewert', sans-serif"
}, {
  "name": "Exo",
  "category": "sans-serif",
  "value": "'Exo', sans-serif"
}, {
  "name": "Exo 2",
  "category": "sans-serif",
  "value": "'Exo 2', sans-serif"
}, {
  "name": "Expletus Sans",
  "category": "display",
  "value": "'Expletus Sans', sans-serif"
}, {
  "name": "Explora",
  "category": "handwriting",
  "value": "'Explora', cursive"
}, {
  "name": "Fahkwang",
  "category": "sans-serif",
  "value": "'Fahkwang', sans-serif"
}, {
  "name": "Fanwood Text",
  "category": "serif",
  "value": "'Fanwood Text', serif"
}, {
  "name": "Farro",
  "category": "sans-serif",
  "value": "'Farro', sans-serif"
}, {
  "name": "Farsan",
  "category": "display",
  "value": "'Farsan', sans-serif"
}, {
  "name": "Fascinate",
  "category": "display",
  "value": "'Fascinate', sans-serif"
}, {
  "name": "Fascinate Inline",
  "category": "display",
  "value": "'Fascinate Inline', sans-serif"
}, {
  "name": "Faster One",
  "category": "display",
  "value": "'Faster One', sans-serif"
}, {
  "name": "Fasthand",
  "category": "display",
  "value": "'Fasthand', sans-serif"
}, {
  "name": "Fauna One",
  "category": "serif",
  "value": "'Fauna One', serif"
}, {
  "name": "Faustina",
  "category": "serif",
  "value": "'Faustina', serif"
}, {
  "name": "Federant",
  "category": "display",
  "value": "'Federant', sans-serif"
}, {
  "name": "Federo",
  "category": "sans-serif",
  "value": "'Federo', sans-serif"
}, {
  "name": "Felipa",
  "category": "handwriting",
  "value": "'Felipa', cursive"
}, {
  "name": "Fenix",
  "category": "serif",
  "value": "'Fenix', serif"
}, {
  "name": "Festive",
  "category": "handwriting",
  "value": "'Festive', cursive"
}, {
  "name": "Finger Paint",
  "category": "display",
  "value": "'Finger Paint', sans-serif"
}, {
  "name": "Fira Code",
  "category": "monospace",
  "value": "'Fira Code', monospace"
}, {
  "name": "Fira Mono",
  "category": "monospace",
  "value": "'Fira Mono', monospace"
}, {
  "name": "Fira Sans",
  "category": "sans-serif",
  "value": "'Fira Sans', sans-serif"
}, {
  "name": "Fira Sans Condensed",
  "category": "sans-serif",
  "value": "'Fira Sans Condensed', sans-serif"
}, {
  "name": "Fira Sans Extra Condensed",
  "category": "sans-serif",
  "value": "'Fira Sans Extra Condensed', sans-serif"
}, {
  "name": "Fjalla One",
  "category": "sans-serif",
  "value": "'Fjalla One', sans-serif"
}, {
  "name": "Fjord One",
  "category": "serif",
  "value": "'Fjord One', serif"
}, {
  "name": "Flamenco",
  "category": "display",
  "value": "'Flamenco', sans-serif"
}, {
  "name": "Flavors",
  "category": "display",
  "value": "'Flavors', sans-serif"
}, {
  "name": "Fleur De Leah",
  "category": "handwriting",
  "value": "'Fleur De Leah', cursive"
}, {
  "name": "Fondamento",
  "category": "handwriting",
  "value": "'Fondamento', cursive"
}, {
  "name": "Fontdiner Swanky",
  "category": "display",
  "value": "'Fontdiner Swanky', sans-serif"
}, {
  "name": "Forum",
  "category": "display",
  "value": "'Forum', sans-serif"
}, {
  "name": "Francois One",
  "category": "sans-serif",
  "value": "'Francois One', sans-serif"
}, {
  "name": "Frank Ruhl Libre",
  "category": "serif",
  "value": "'Frank Ruhl Libre', serif"
}, {
  "name": "Fraunces",
  "category": "serif",
  "value": "'Fraunces', serif"
}, {
  "name": "Freckle Face",
  "category": "display",
  "value": "'Freckle Face', sans-serif"
}, {
  "name": "Fredericka the Great",
  "category": "display",
  "value": "'Fredericka the Great', sans-serif"
}, {
  "name": "Fredoka One",
  "category": "display",
  "value": "'Fredoka One', sans-serif"
}, {
  "name": "Freehand",
  "category": "display",
  "value": "'Freehand', sans-serif"
}, {
  "name": "Fresca",
  "category": "sans-serif",
  "value": "'Fresca', sans-serif"
}, {
  "name": "Frijole",
  "category": "display",
  "value": "'Frijole', sans-serif"
}, {
  "name": "Fruktur",
  "category": "display",
  "value": "'Fruktur', sans-serif"
}, {
  "name": "Fugaz One",
  "category": "display",
  "value": "'Fugaz One', sans-serif"
}, {
  "name": "Fuggles",
  "category": "handwriting",
  "value": "'Fuggles', cursive"
}, {
  "name": "Gabriela",
  "category": "serif",
  "value": "'Gabriela', serif"
}, {
  "name": "Gaegu",
  "category": "handwriting",
  "value": "'Gaegu', cursive"
}, {
  "name": "Gafata",
  "category": "sans-serif",
  "value": "'Gafata', sans-serif"
}, {
  "name": "Galada",
  "category": "display",
  "value": "'Galada', sans-serif"
}, {
  "name": "Galdeano",
  "category": "sans-serif",
  "value": "'Galdeano', sans-serif"
}, {
  "name": "Galindo",
  "category": "display",
  "value": "'Galindo', sans-serif"
}, {
  "name": "Gamja Flower",
  "category": "handwriting",
  "value": "'Gamja Flower', cursive"
}, {
  "name": "Gayathri",
  "category": "sans-serif",
  "value": "'Gayathri', sans-serif"
}, {
  "name": "Gelasio",
  "category": "serif",
  "value": "'Gelasio', serif"
}, {
  "name": "Gemunu Libre",
  "category": "sans-serif",
  "value": "'Gemunu Libre', sans-serif"
}, {
  "name": "Gentium Basic",
  "category": "serif",
  "value": "'Gentium Basic', serif"
}, {
  "name": "Gentium Book Basic",
  "category": "serif",
  "value": "'Gentium Book Basic', serif"
}, {
  "name": "Geo",
  "category": "sans-serif",
  "value": "'Geo', sans-serif"
}, {
  "name": "Georama",
  "category": "sans-serif",
  "value": "'Georama', sans-serif"
}, {
  "name": "Geostar",
  "category": "display",
  "value": "'Geostar', sans-serif"
}, {
  "name": "Geostar Fill",
  "category": "display",
  "value": "'Geostar Fill', sans-serif"
}, {
  "name": "Germania One",
  "category": "display",
  "value": "'Germania One', sans-serif"
}, {
  "name": "GFS Didot",
  "category": "serif",
  "value": "'GFS Didot', serif"
}, {
  "name": "GFS Neohellenic",
  "category": "sans-serif",
  "value": "'GFS Neohellenic', sans-serif"
}, {
  "name": "Gideon Roman",
  "category": "display",
  "value": "'Gideon Roman', sans-serif"
}, {
  "name": "Gidugu",
  "category": "sans-serif",
  "value": "'Gidugu', sans-serif"
}, {
  "name": "Gilda Display",
  "category": "serif",
  "value": "'Gilda Display', serif"
}, {
  "name": "Girassol",
  "category": "display",
  "value": "'Girassol', sans-serif"
}, {
  "name": "Give You Glory",
  "category": "handwriting",
  "value": "'Give You Glory', cursive"
}, {
  "name": "Glass Antiqua",
  "category": "display",
  "value": "'Glass Antiqua', sans-serif"
}, {
  "name": "Glegoo",
  "category": "serif",
  "value": "'Glegoo', serif"
}, {
  "name": "Gloria Hallelujah",
  "category": "handwriting",
  "value": "'Gloria Hallelujah', cursive"
}, {
  "name": "Glory",
  "category": "sans-serif",
  "value": "'Glory', sans-serif"
}, {
  "name": "Gluten",
  "category": "display",
  "value": "'Gluten', sans-serif"
}, {
  "name": "Goblin One",
  "category": "display",
  "value": "'Goblin One', sans-serif"
}, {
  "name": "Gochi Hand",
  "category": "handwriting",
  "value": "'Gochi Hand', cursive"
}, {
  "name": "Goldman",
  "category": "display",
  "value": "'Goldman', sans-serif"
}, {
  "name": "Gorditas",
  "category": "display",
  "value": "'Gorditas', sans-serif"
}, {
  "name": "Gothic A1",
  "category": "sans-serif",
  "value": "'Gothic A1', sans-serif"
}, {
  "name": "Gotu",
  "category": "sans-serif",
  "value": "'Gotu', sans-serif"
}, {
  "name": "Goudy Bookletter 1911",
  "category": "serif",
  "value": "'Goudy Bookletter 1911', serif"
}, {
  "name": "Gowun Batang",
  "category": "serif",
  "value": "'Gowun Batang', serif"
}, {
  "name": "Gowun Dodum",
  "category": "sans-serif",
  "value": "'Gowun Dodum', sans-serif"
}, {
  "name": "Graduate",
  "category": "display",
  "value": "'Graduate', sans-serif"
}, {
  "name": "Grand Hotel",
  "category": "handwriting",
  "value": "'Grand Hotel', cursive"
}, {
  "name": "Grandstander",
  "category": "display",
  "value": "'Grandstander', sans-serif"
}, {
  "name": "Gravitas One",
  "category": "display",
  "value": "'Gravitas One', sans-serif"
}, {
  "name": "Great Vibes",
  "category": "handwriting",
  "value": "'Great Vibes', cursive"
}, {
  "name": "Grechen Fuemen",
  "category": "handwriting",
  "value": "'Grechen Fuemen', cursive"
}, {
  "name": "Grenze",
  "category": "serif",
  "value": "'Grenze', serif"
}, {
  "name": "Grenze Gotisch",
  "category": "display",
  "value": "'Grenze Gotisch', sans-serif"
}, {
  "name": "Grey Qo",
  "category": "handwriting",
  "value": "'Grey Qo', cursive"
}, {
  "name": "Griffy",
  "category": "display",
  "value": "'Griffy', sans-serif"
}, {
  "name": "Gruppo",
  "category": "display",
  "value": "'Gruppo', sans-serif"
}, {
  "name": "Gudea",
  "category": "sans-serif",
  "value": "'Gudea', sans-serif"
}, {
  "name": "Gugi",
  "category": "display",
  "value": "'Gugi', sans-serif"
}, {
  "name": "Gupter",
  "category": "serif",
  "value": "'Gupter', serif"
}, {
  "name": "Gurajada",
  "category": "serif",
  "value": "'Gurajada', serif"
}, {
  "name": "Habibi",
  "category": "serif",
  "value": "'Habibi', serif"
}, {
  "name": "Hachi Maru Pop",
  "category": "handwriting",
  "value": "'Hachi Maru Pop', cursive"
}, {
  "name": "Hahmlet",
  "category": "serif",
  "value": "'Hahmlet', serif"
}, {
  "name": "Halant",
  "category": "serif",
  "value": "'Halant', serif"
}, {
  "name": "Hammersmith One",
  "category": "sans-serif",
  "value": "'Hammersmith One', sans-serif"
}, {
  "name": "Hanalei",
  "category": "display",
  "value": "'Hanalei', sans-serif"
}, {
  "name": "Hanalei Fill",
  "category": "display",
  "value": "'Hanalei Fill', sans-serif"
}, {
  "name": "Handlee",
  "category": "handwriting",
  "value": "'Handlee', cursive"
}, {
  "name": "Hanuman",
  "category": "serif",
  "value": "'Hanuman', serif"
}, {
  "name": "Happy Monkey",
  "category": "display",
  "value": "'Happy Monkey', sans-serif"
}, {
  "name": "Harmattan",
  "category": "sans-serif",
  "value": "'Harmattan', sans-serif"
}, {
  "name": "Headland One",
  "category": "serif",
  "value": "'Headland One', serif"
}, {
  "name": "Heebo",
  "category": "sans-serif",
  "value": "'Heebo', sans-serif"
}, {
  "name": "Henny Penny",
  "category": "display",
  "value": "'Henny Penny', sans-serif"
}, {
  "name": "Hepta Slab",
  "category": "serif",
  "value": "'Hepta Slab', serif"
}, {
  "name": "Herr Von Muellerhoff",
  "category": "handwriting",
  "value": "'Herr Von Muellerhoff', cursive"
}, {
  "name": "Hi Melody",
  "category": "handwriting",
  "value": "'Hi Melody', cursive"
}, {
  "name": "Hina Mincho",
  "category": "serif",
  "value": "'Hina Mincho', serif"
}, {
  "name": "Hind",
  "category": "sans-serif",
  "value": "'Hind', sans-serif"
}, {
  "name": "Hind Guntur",
  "category": "sans-serif",
  "value": "'Hind Guntur', sans-serif"
}, {
  "name": "Hind Madurai",
  "category": "sans-serif",
  "value": "'Hind Madurai', sans-serif"
}, {
  "name": "Hind Siliguri",
  "category": "sans-serif",
  "value": "'Hind Siliguri', sans-serif"
}, {
  "name": "Hind Vadodara",
  "category": "sans-serif",
  "value": "'Hind Vadodara', sans-serif"
}, {
  "name": "Holtwood One SC",
  "category": "serif",
  "value": "'Holtwood One SC', serif"
}, {
  "name": "Homemade Apple",
  "category": "handwriting",
  "value": "'Homemade Apple', cursive"
}, {
  "name": "Homenaje",
  "category": "sans-serif",
  "value": "'Homenaje', sans-serif"
}, {
  "name": "Ibarra Real Nova",
  "category": "serif",
  "value": "'Ibarra Real Nova', serif"
}, {
  "name": "IBM Plex Mono",
  "category": "monospace",
  "value": "'IBM Plex Mono', monospace"
}, {
  "name": "IBM Plex Sans",
  "category": "sans-serif",
  "value": "'IBM Plex Sans', sans-serif"
}, {
  "name": "IBM Plex Sans Arabic",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Arabic', sans-serif"
}, {
  "name": "IBM Plex Sans Condensed",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Condensed', sans-serif"
}, {
  "name": "IBM Plex Sans Devanagari",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Devanagari', sans-serif"
}, {
  "name": "IBM Plex Sans Hebrew",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Hebrew', sans-serif"
}, {
  "name": "IBM Plex Sans KR",
  "category": "sans-serif",
  "value": "'IBM Plex Sans KR', sans-serif"
}, {
  "name": "IBM Plex Sans Thai",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Thai', sans-serif"
}, {
  "name": "IBM Plex Sans Thai Looped",
  "category": "sans-serif",
  "value": "'IBM Plex Sans Thai Looped', sans-serif"
}, {
  "name": "IBM Plex Serif",
  "category": "serif",
  "value": "'IBM Plex Serif', serif"
}, {
  "name": "Iceberg",
  "category": "display",
  "value": "'Iceberg', sans-serif"
}, {
  "name": "Iceland",
  "category": "display",
  "value": "'Iceland', sans-serif"
}, {
  "name": "IM Fell Double Pica",
  "category": "serif",
  "value": "'IM Fell Double Pica', serif"
}, {
  "name": "IM Fell Double Pica SC",
  "category": "serif",
  "value": "'IM Fell Double Pica SC', serif"
}, {
  "name": "IM Fell DW Pica",
  "category": "serif",
  "value": "'IM Fell DW Pica', serif"
}, {
  "name": "IM Fell DW Pica SC",
  "category": "serif",
  "value": "'IM Fell DW Pica SC', serif"
}, {
  "name": "IM Fell English",
  "category": "serif",
  "value": "'IM Fell English', serif"
}, {
  "name": "IM Fell English SC",
  "category": "serif",
  "value": "'IM Fell English SC', serif"
}, {
  "name": "IM Fell French Canon",
  "category": "serif",
  "value": "'IM Fell French Canon', serif"
}, {
  "name": "IM Fell French Canon SC",
  "category": "serif",
  "value": "'IM Fell French Canon SC', serif"
}, {
  "name": "IM Fell Great Primer",
  "category": "serif",
  "value": "'IM Fell Great Primer', serif"
}, {
  "name": "IM Fell Great Primer SC",
  "category": "serif",
  "value": "'IM Fell Great Primer SC', serif"
}, {
  "name": "Imbue",
  "category": "serif",
  "value": "'Imbue', serif"
}, {
  "name": "Imprima",
  "category": "sans-serif",
  "value": "'Imprima', sans-serif"
}, {
  "name": "Inconsolata",
  "category": "monospace",
  "value": "'Inconsolata', monospace"
}, {
  "name": "Inder",
  "category": "sans-serif",
  "value": "'Inder', sans-serif"
}, {
  "name": "Indie Flower",
  "category": "handwriting",
  "value": "'Indie Flower', cursive"
}, {
  "name": "Inika",
  "category": "serif",
  "value": "'Inika', serif"
}, {
  "name": "Inknut Antiqua",
  "category": "serif",
  "value": "'Inknut Antiqua', serif"
}, {
  "name": "Inria Sans",
  "category": "sans-serif",
  "value": "'Inria Sans', sans-serif"
}, {
  "name": "Inria Serif",
  "category": "serif",
  "value": "'Inria Serif', serif"
}, {
  "name": "Inter",
  "category": "sans-serif",
  "value": "'Inter', sans-serif"
}, {
  "name": "Irish Grover",
  "category": "display",
  "value": "'Irish Grover', sans-serif"
}, {
  "name": "Istok Web",
  "category": "sans-serif",
  "value": "'Istok Web', sans-serif"
}, {
  "name": "Italiana",
  "category": "serif",
  "value": "'Italiana', serif"
}, {
  "name": "Italianno",
  "category": "handwriting",
  "value": "'Italianno', cursive"
}, {
  "name": "Itim",
  "category": "handwriting",
  "value": "'Itim', cursive"
}, {
  "name": "Jacques Francois",
  "category": "serif",
  "value": "'Jacques Francois', serif"
}, {
  "name": "Jacques Francois Shadow",
  "category": "display",
  "value": "'Jacques Francois Shadow', sans-serif"
}, {
  "name": "Jaldi",
  "category": "sans-serif",
  "value": "'Jaldi', sans-serif"
}, {
  "name": "JetBrains Mono",
  "category": "monospace",
  "value": "'JetBrains Mono', monospace"
}, {
  "name": "Jim Nightshade",
  "category": "handwriting",
  "value": "'Jim Nightshade', cursive"
}, {
  "name": "Jockey One",
  "category": "sans-serif",
  "value": "'Jockey One', sans-serif"
}, {
  "name": "Jolly Lodger",
  "category": "display",
  "value": "'Jolly Lodger', sans-serif"
}, {
  "name": "Jomhuria",
  "category": "display",
  "value": "'Jomhuria', sans-serif"
}, {
  "name": "Jomolhari",
  "category": "serif",
  "value": "'Jomolhari', serif"
}, {
  "name": "Josefin Sans",
  "category": "sans-serif",
  "value": "'Josefin Sans', sans-serif"
}, {
  "name": "Josefin Slab",
  "category": "serif",
  "value": "'Josefin Slab', serif"
}, {
  "name": "Jost",
  "category": "sans-serif",
  "value": "'Jost', sans-serif"
}, {
  "name": "Joti One",
  "category": "display",
  "value": "'Joti One', sans-serif"
}, {
  "name": "Jua",
  "category": "sans-serif",
  "value": "'Jua', sans-serif"
}, {
  "name": "Judson",
  "category": "serif",
  "value": "'Judson', serif"
}, {
  "name": "Julee",
  "category": "handwriting",
  "value": "'Julee', cursive"
}, {
  "name": "Julius Sans One",
  "category": "sans-serif",
  "value": "'Julius Sans One', sans-serif"
}, {
  "name": "Junge",
  "category": "serif",
  "value": "'Junge', serif"
}, {
  "name": "Jura",
  "category": "sans-serif",
  "value": "'Jura', sans-serif"
}, {
  "name": "Just Another Hand",
  "category": "handwriting",
  "value": "'Just Another Hand', cursive"
}, {
  "name": "Just Me Again Down Here",
  "category": "handwriting",
  "value": "'Just Me Again Down Here', cursive"
}, {
  "name": "K2D",
  "category": "sans-serif",
  "value": "'K2D', sans-serif"
}, {
  "name": "Kadwa",
  "category": "serif",
  "value": "'Kadwa', serif"
}, {
  "name": "Kaisei Decol",
  "category": "serif",
  "value": "'Kaisei Decol', serif"
}, {
  "name": "Kaisei HarunoUmi",
  "category": "serif",
  "value": "'Kaisei HarunoUmi', serif"
}, {
  "name": "Kaisei Opti",
  "category": "serif",
  "value": "'Kaisei Opti', serif"
}, {
  "name": "Kaisei Tokumin",
  "category": "serif",
  "value": "'Kaisei Tokumin', serif"
}, {
  "name": "Kalam",
  "category": "handwriting",
  "value": "'Kalam', cursive"
}, {
  "name": "Kameron",
  "category": "serif",
  "value": "'Kameron', serif"
}, {
  "name": "Kanit",
  "category": "sans-serif",
  "value": "'Kanit', sans-serif"
}, {
  "name": "Kantumruy",
  "category": "sans-serif",
  "value": "'Kantumruy', sans-serif"
}, {
  "name": "Karantina",
  "category": "display",
  "value": "'Karantina', sans-serif"
}, {
  "name": "Karla",
  "category": "sans-serif",
  "value": "'Karla', sans-serif"
}, {
  "name": "Karma",
  "category": "serif",
  "value": "'Karma', serif"
}, {
  "name": "Katibeh",
  "category": "display",
  "value": "'Katibeh', sans-serif"
}, {
  "name": "Kaushan Script",
  "category": "handwriting",
  "value": "'Kaushan Script', cursive"
}, {
  "name": "Kavivanar",
  "category": "handwriting",
  "value": "'Kavivanar', cursive"
}, {
  "name": "Kavoon",
  "category": "display",
  "value": "'Kavoon', sans-serif"
}, {
  "name": "Kdam Thmor",
  "category": "display",
  "value": "'Kdam Thmor', sans-serif"
}, {
  "name": "Keania One",
  "category": "display",
  "value": "'Keania One', sans-serif"
}, {
  "name": "Kelly Slab",
  "category": "display",
  "value": "'Kelly Slab', sans-serif"
}, {
  "name": "Kenia",
  "category": "display",
  "value": "'Kenia', sans-serif"
}, {
  "name": "Khand",
  "category": "sans-serif",
  "value": "'Khand', sans-serif"
}, {
  "name": "Khmer",
  "category": "display",
  "value": "'Khmer', sans-serif"
}, {
  "name": "Khula",
  "category": "sans-serif",
  "value": "'Khula', sans-serif"
}, {
  "name": "Kirang Haerang",
  "category": "display",
  "value": "'Kirang Haerang', sans-serif"
}, {
  "name": "Kite One",
  "category": "sans-serif",
  "value": "'Kite One', sans-serif"
}, {
  "name": "Kiwi Maru",
  "category": "serif",
  "value": "'Kiwi Maru', serif"
}, {
  "name": "Klee One",
  "category": "handwriting",
  "value": "'Klee One', cursive"
}, {
  "name": "Knewave",
  "category": "display",
  "value": "'Knewave', sans-serif"
}, {
  "name": "Kodchasan",
  "category": "sans-serif",
  "value": "'Kodchasan', sans-serif"
}, {
  "name": "Koh Santepheap",
  "category": "display",
  "value": "'Koh Santepheap', sans-serif"
}, {
  "name": "KoHo",
  "category": "sans-serif",
  "value": "'KoHo', sans-serif"
}, {
  "name": "Kosugi",
  "category": "sans-serif",
  "value": "'Kosugi', sans-serif"
}, {
  "name": "Kosugi Maru",
  "category": "sans-serif",
  "value": "'Kosugi Maru', sans-serif"
}, {
  "name": "Kotta One",
  "category": "serif",
  "value": "'Kotta One', serif"
}, {
  "name": "Koulen",
  "category": "display",
  "value": "'Koulen', sans-serif"
}, {
  "name": "Kranky",
  "category": "display",
  "value": "'Kranky', sans-serif"
}, {
  "name": "Kreon",
  "category": "serif",
  "value": "'Kreon', serif"
}, {
  "name": "Kristi",
  "category": "handwriting",
  "value": "'Kristi', cursive"
}, {
  "name": "Krona One",
  "category": "sans-serif",
  "value": "'Krona One', sans-serif"
}, {
  "name": "Krub",
  "category": "sans-serif",
  "value": "'Krub', sans-serif"
}, {
  "name": "Kufam",
  "category": "sans-serif",
  "value": "'Kufam', sans-serif"
}, {
  "name": "Kulim Park",
  "category": "sans-serif",
  "value": "'Kulim Park', sans-serif"
}, {
  "name": "Kumar One",
  "category": "display",
  "value": "'Kumar One', sans-serif"
}, {
  "name": "Kumar One Outline",
  "category": "display",
  "value": "'Kumar One Outline', sans-serif"
}, {
  "name": "Kumbh Sans",
  "category": "sans-serif",
  "value": "'Kumbh Sans', sans-serif"
}, {
  "name": "Kurale",
  "category": "serif",
  "value": "'Kurale', serif"
}, {
  "name": "La Belle Aurore",
  "category": "handwriting",
  "value": "'La Belle Aurore', cursive"
}, {
  "name": "Lacquer",
  "category": "display",
  "value": "'Lacquer', sans-serif"
}, {
  "name": "Laila",
  "category": "sans-serif",
  "value": "'Laila', sans-serif"
}, {
  "name": "Lakki Reddy",
  "category": "handwriting",
  "value": "'Lakki Reddy', cursive"
}, {
  "name": "Lalezar",
  "category": "display",
  "value": "'Lalezar', sans-serif"
}, {
  "name": "Lancelot",
  "category": "display",
  "value": "'Lancelot', sans-serif"
}, {
  "name": "Langar",
  "category": "display",
  "value": "'Langar', sans-serif"
}, {
  "name": "Lateef",
  "category": "handwriting",
  "value": "'Lateef', cursive"
}, {
  "name": "Lato",
  "category": "sans-serif",
  "value": "'Lato', sans-serif"
}, {
  "name": "League Script",
  "category": "handwriting",
  "value": "'League Script', cursive"
}, {
  "name": "Leckerli One",
  "category": "handwriting",
  "value": "'Leckerli One', cursive"
}, {
  "name": "Ledger",
  "category": "serif",
  "value": "'Ledger', serif"
}, {
  "name": "Lekton",
  "category": "sans-serif",
  "value": "'Lekton', sans-serif"
}, {
  "name": "Lemon",
  "category": "display",
  "value": "'Lemon', sans-serif"
}, {
  "name": "Lemonada",
  "category": "display",
  "value": "'Lemonada', sans-serif"
}, {
  "name": "Lexend",
  "category": "sans-serif",
  "value": "'Lexend', sans-serif"
}, {
  "name": "Lexend Deca",
  "category": "sans-serif",
  "value": "'Lexend Deca', sans-serif"
}, {
  "name": "Lexend Exa",
  "category": "sans-serif",
  "value": "'Lexend Exa', sans-serif"
}, {
  "name": "Lexend Giga",
  "category": "sans-serif",
  "value": "'Lexend Giga', sans-serif"
}, {
  "name": "Lexend Mega",
  "category": "sans-serif",
  "value": "'Lexend Mega', sans-serif"
}, {
  "name": "Lexend Peta",
  "category": "sans-serif",
  "value": "'Lexend Peta', sans-serif"
}, {
  "name": "Lexend Tera",
  "category": "sans-serif",
  "value": "'Lexend Tera', sans-serif"
}, {
  "name": "Lexend Zetta",
  "category": "sans-serif",
  "value": "'Lexend Zetta', sans-serif"
}, {
  "name": "Libre Barcode 128",
  "category": "display",
  "value": "'Libre Barcode 128', sans-serif"
}, {
  "name": "Libre Barcode 128 Text",
  "category": "display",
  "value": "'Libre Barcode 128 Text', sans-serif"
}, {
  "name": "Libre Barcode 39",
  "category": "display",
  "value": "'Libre Barcode 39', sans-serif"
}, {
  "name": "Libre Barcode 39 Extended",
  "category": "display",
  "value": "'Libre Barcode 39 Extended', sans-serif"
}, {
  "name": "Libre Barcode 39 Extended Text",
  "category": "display",
  "value": "'Libre Barcode 39 Extended Text', sans-serif"
}, {
  "name": "Libre Barcode 39 Text",
  "category": "display",
  "value": "'Libre Barcode 39 Text', sans-serif"
}, {
  "name": "Libre Barcode EAN13 Text",
  "category": "display",
  "value": "'Libre Barcode EAN13 Text', sans-serif"
}, {
  "name": "Libre Baskerville",
  "category": "serif",
  "value": "'Libre Baskerville', serif"
}, {
  "name": "Libre Caslon Display",
  "category": "serif",
  "value": "'Libre Caslon Display', serif"
}, {
  "name": "Libre Caslon Text",
  "category": "serif",
  "value": "'Libre Caslon Text', serif"
}, {
  "name": "Libre Franklin",
  "category": "sans-serif",
  "value": "'Libre Franklin', sans-serif"
}, {
  "name": "Life Savers",
  "category": "display",
  "value": "'Life Savers', sans-serif"
}, {
  "name": "Lilita One",
  "category": "display",
  "value": "'Lilita One', sans-serif"
}, {
  "name": "Lily Script One",
  "category": "display",
  "value": "'Lily Script One', sans-serif"
}, {
  "name": "Limelight",
  "category": "display",
  "value": "'Limelight', sans-serif"
}, {
  "name": "Linden Hill",
  "category": "serif",
  "value": "'Linden Hill', serif"
}, {
  "name": "Literata",
  "category": "serif",
  "value": "'Literata', serif"
}, {
  "name": "Liu Jian Mao Cao",
  "category": "handwriting",
  "value": "'Liu Jian Mao Cao', cursive"
}, {
  "name": "Livvic",
  "category": "sans-serif",
  "value": "'Livvic', sans-serif"
}, {
  "name": "Lobster",
  "category": "display",
  "value": "'Lobster', sans-serif"
}, {
  "name": "Lobster Two",
  "category": "display",
  "value": "'Lobster Two', sans-serif"
}, {
  "name": "Londrina Outline",
  "category": "display",
  "value": "'Londrina Outline', sans-serif"
}, {
  "name": "Londrina Shadow",
  "category": "display",
  "value": "'Londrina Shadow', sans-serif"
}, {
  "name": "Londrina Sketch",
  "category": "display",
  "value": "'Londrina Sketch', sans-serif"
}, {
  "name": "Londrina Solid",
  "category": "display",
  "value": "'Londrina Solid', sans-serif"
}, {
  "name": "Long Cang",
  "category": "handwriting",
  "value": "'Long Cang', cursive"
}, {
  "name": "Lora",
  "category": "serif",
  "value": "'Lora', serif"
}, {
  "name": "Love Ya Like A Sister",
  "category": "display",
  "value": "'Love Ya Like A Sister', sans-serif"
}, {
  "name": "Loved by the King",
  "category": "handwriting",
  "value": "'Loved by the King', cursive"
}, {
  "name": "Lovers Quarrel",
  "category": "handwriting",
  "value": "'Lovers Quarrel', cursive"
}, {
  "name": "Luckiest Guy",
  "category": "display",
  "value": "'Luckiest Guy', sans-serif"
}, {
  "name": "Lusitana",
  "category": "serif",
  "value": "'Lusitana', serif"
}, {
  "name": "Lustria",
  "category": "serif",
  "value": "'Lustria', serif"
}, {
  "name": "M PLUS 1p",
  "category": "sans-serif",
  "value": "'M PLUS 1p', sans-serif"
}, {
  "name": "M PLUS Rounded 1c",
  "category": "sans-serif",
  "value": "'M PLUS Rounded 1c', sans-serif"
}, {
  "name": "Ma Shan Zheng",
  "category": "handwriting",
  "value": "'Ma Shan Zheng', cursive"
}, {
  "name": "Macondo",
  "category": "display",
  "value": "'Macondo', sans-serif"
}, {
  "name": "Macondo Swash Caps",
  "category": "display",
  "value": "'Macondo Swash Caps', sans-serif"
}, {
  "name": "Mada",
  "category": "sans-serif",
  "value": "'Mada', sans-serif"
}, {
  "name": "Magra",
  "category": "sans-serif",
  "value": "'Magra', sans-serif"
}, {
  "name": "Maiden Orange",
  "category": "display",
  "value": "'Maiden Orange', sans-serif"
}, {
  "name": "Maitree",
  "category": "serif",
  "value": "'Maitree', serif"
}, {
  "name": "Major Mono Display",
  "category": "monospace",
  "value": "'Major Mono Display', monospace"
}, {
  "name": "Mako",
  "category": "sans-serif",
  "value": "'Mako', sans-serif"
}, {
  "name": "Mali",
  "category": "handwriting",
  "value": "'Mali', cursive"
}, {
  "name": "Mallanna",
  "category": "sans-serif",
  "value": "'Mallanna', sans-serif"
}, {
  "name": "Mandali",
  "category": "sans-serif",
  "value": "'Mandali', sans-serif"
}, {
  "name": "Manjari",
  "category": "sans-serif",
  "value": "'Manjari', sans-serif"
}, {
  "name": "Manrope",
  "category": "sans-serif",
  "value": "'Manrope', sans-serif"
}, {
  "name": "Mansalva",
  "category": "handwriting",
  "value": "'Mansalva', cursive"
}, {
  "name": "Manuale",
  "category": "serif",
  "value": "'Manuale', serif"
}, {
  "name": "Marcellus",
  "category": "serif",
  "value": "'Marcellus', serif"
}, {
  "name": "Marcellus SC",
  "category": "serif",
  "value": "'Marcellus SC', serif"
}, {
  "name": "Marck Script",
  "category": "handwriting",
  "value": "'Marck Script', cursive"
}, {
  "name": "Margarine",
  "category": "display",
  "value": "'Margarine', sans-serif"
}, {
  "name": "Markazi Text",
  "category": "serif",
  "value": "'Markazi Text', serif"
}, {
  "name": "Marko One",
  "category": "serif",
  "value": "'Marko One', serif"
}, {
  "name": "Marmelad",
  "category": "sans-serif",
  "value": "'Marmelad', sans-serif"
}, {
  "name": "Martel",
  "category": "serif",
  "value": "'Martel', serif"
}, {
  "name": "Martel Sans",
  "category": "sans-serif",
  "value": "'Martel Sans', sans-serif"
}, {
  "name": "Marvel",
  "category": "sans-serif",
  "value": "'Marvel', sans-serif"
}, {
  "name": "Mate",
  "category": "serif",
  "value": "'Mate', serif"
}, {
  "name": "Mate SC",
  "category": "serif",
  "value": "'Mate SC', serif"
}, {
  "name": "Maven Pro",
  "category": "sans-serif",
  "value": "'Maven Pro', sans-serif"
}, {
  "name": "McLaren",
  "category": "display",
  "value": "'McLaren', sans-serif"
}, {
  "name": "Meddon",
  "category": "handwriting",
  "value": "'Meddon', cursive"
}, {
  "name": "MedievalSharp",
  "category": "display",
  "value": "'MedievalSharp', sans-serif"
}, {
  "name": "Medula One",
  "category": "display",
  "value": "'Medula One', sans-serif"
}, {
  "name": "Meera Inimai",
  "category": "sans-serif",
  "value": "'Meera Inimai', sans-serif"
}, {
  "name": "Megrim",
  "category": "display",
  "value": "'Megrim', sans-serif"
}, {
  "name": "Meie Script",
  "category": "handwriting",
  "value": "'Meie Script', cursive"
}, {
  "name": "Merienda",
  "category": "handwriting",
  "value": "'Merienda', cursive"
}, {
  "name": "Merienda One",
  "category": "handwriting",
  "value": "'Merienda One', cursive"
}, {
  "name": "Merriweather",
  "category": "serif",
  "value": "'Merriweather', serif"
}, {
  "name": "Merriweather Sans",
  "category": "sans-serif",
  "value": "'Merriweather Sans', sans-serif"
}, {
  "name": "Metal",
  "category": "display",
  "value": "'Metal', sans-serif"
}, {
  "name": "Metal Mania",
  "category": "display",
  "value": "'Metal Mania', sans-serif"
}, {
  "name": "Metamorphous",
  "category": "display",
  "value": "'Metamorphous', sans-serif"
}, {
  "name": "Metrophobic",
  "category": "sans-serif",
  "value": "'Metrophobic', sans-serif"
}, {
  "name": "Michroma",
  "category": "sans-serif",
  "value": "'Michroma', sans-serif"
}, {
  "name": "Milonga",
  "category": "display",
  "value": "'Milonga', sans-serif"
}, {
  "name": "Miltonian",
  "category": "display",
  "value": "'Miltonian', sans-serif"
}, {
  "name": "Miltonian Tattoo",
  "category": "display",
  "value": "'Miltonian Tattoo', sans-serif"
}, {
  "name": "Mina",
  "category": "sans-serif",
  "value": "'Mina', sans-serif"
}, {
  "name": "Miniver",
  "category": "display",
  "value": "'Miniver', sans-serif"
}, {
  "name": "Miriam Libre",
  "category": "sans-serif",
  "value": "'Miriam Libre', sans-serif"
}, {
  "name": "Mirza",
  "category": "display",
  "value": "'Mirza', sans-serif"
}, {
  "name": "Miss Fajardose",
  "category": "handwriting",
  "value": "'Miss Fajardose', cursive"
}, {
  "name": "Mitr",
  "category": "sans-serif",
  "value": "'Mitr', sans-serif"
}, {
  "name": "Modak",
  "category": "display",
  "value": "'Modak', sans-serif"
}, {
  "name": "Modern Antiqua",
  "category": "display",
  "value": "'Modern Antiqua', sans-serif"
}, {
  "name": "Mogra",
  "category": "display",
  "value": "'Mogra', sans-serif"
}, {
  "name": "Molengo",
  "category": "sans-serif",
  "value": "'Molengo', sans-serif"
}, {
  "name": "Molle",
  "category": "handwriting",
  "value": "'Molle', cursive"
}, {
  "name": "Monda",
  "category": "sans-serif",
  "value": "'Monda', sans-serif"
}, {
  "name": "Monofett",
  "category": "display",
  "value": "'Monofett', sans-serif"
}, {
  "name": "Monoton",
  "category": "display",
  "value": "'Monoton', sans-serif"
}, {
  "name": "Monsieur La Doulaise",
  "category": "handwriting",
  "value": "'Monsieur La Doulaise', cursive"
}, {
  "name": "Montaga",
  "category": "serif",
  "value": "'Montaga', serif"
}, {
  "name": "MonteCarlo",
  "category": "handwriting",
  "value": "'MonteCarlo', cursive"
}, {
  "name": "Montez",
  "category": "handwriting",
  "value": "'Montez', cursive"
}, {
  "name": "Montserrat",
  "category": "sans-serif",
  "value": "'Montserrat', sans-serif"
}, {
  "name": "Montserrat Alternates",
  "category": "sans-serif",
  "value": "'Montserrat Alternates', sans-serif"
}, {
  "name": "Montserrat Subrayada",
  "category": "sans-serif",
  "value": "'Montserrat Subrayada', sans-serif"
}, {
  "name": "Moul",
  "category": "display",
  "value": "'Moul', sans-serif"
}, {
  "name": "Moulpali",
  "category": "display",
  "value": "'Moulpali', sans-serif"
}, {
  "name": "Mountains of Christmas",
  "category": "display",
  "value": "'Mountains of Christmas', sans-serif"
}, {
  "name": "Mouse Memoirs",
  "category": "sans-serif",
  "value": "'Mouse Memoirs', sans-serif"
}, {
  "name": "Mr Bedfort",
  "category": "handwriting",
  "value": "'Mr Bedfort', cursive"
}, {
  "name": "Mr Dafoe",
  "category": "handwriting",
  "value": "'Mr Dafoe', cursive"
}, {
  "name": "Mr De Haviland",
  "category": "handwriting",
  "value": "'Mr De Haviland', cursive"
}, {
  "name": "Mrs Saint Delafield",
  "category": "handwriting",
  "value": "'Mrs Saint Delafield', cursive"
}, {
  "name": "Mrs Sheppards",
  "category": "handwriting",
  "value": "'Mrs Sheppards', cursive"
}, {
  "name": "Mukta",
  "category": "sans-serif",
  "value": "'Mukta', sans-serif"
}, {
  "name": "Mukta Mahee",
  "category": "sans-serif",
  "value": "'Mukta Mahee', sans-serif"
}, {
  "name": "Mukta Malar",
  "category": "sans-serif",
  "value": "'Mukta Malar', sans-serif"
}, {
  "name": "Mukta Vaani",
  "category": "sans-serif",
  "value": "'Mukta Vaani', sans-serif"
}, {
  "name": "Mulish",
  "category": "sans-serif",
  "value": "'Mulish', sans-serif"
}, {
  "name": "MuseoModerno",
  "category": "display",
  "value": "'MuseoModerno', sans-serif"
}, {
  "name": "Mystery Quest",
  "category": "display",
  "value": "'Mystery Quest', sans-serif"
}, {
  "name": "Nanum Brush Script",
  "category": "handwriting",
  "value": "'Nanum Brush Script', cursive"
}, {
  "name": "Nanum Gothic",
  "category": "sans-serif",
  "value": "'Nanum Gothic', sans-serif"
}, {
  "name": "Nanum Gothic Coding",
  "category": "monospace",
  "value": "'Nanum Gothic Coding', monospace"
}, {
  "name": "Nanum Myeongjo",
  "category": "serif",
  "value": "'Nanum Myeongjo', serif"
}, {
  "name": "Nanum Pen Script",
  "category": "handwriting",
  "value": "'Nanum Pen Script', cursive"
}, {
  "name": "Nerko One",
  "category": "handwriting",
  "value": "'Nerko One', cursive"
}, {
  "name": "Neucha",
  "category": "handwriting",
  "value": "'Neucha', cursive"
}, {
  "name": "Neuton",
  "category": "serif",
  "value": "'Neuton', serif"
}, {
  "name": "New Rocker",
  "category": "display",
  "value": "'New Rocker', sans-serif"
}, {
  "name": "New Tegomin",
  "category": "serif",
  "value": "'New Tegomin', serif"
}, {
  "name": "News Cycle",
  "category": "sans-serif",
  "value": "'News Cycle', sans-serif"
}, {
  "name": "Newsreader",
  "category": "serif",
  "value": "'Newsreader', serif"
}, {
  "name": "Niconne",
  "category": "handwriting",
  "value": "'Niconne', cursive"
}, {
  "name": "Niramit",
  "category": "sans-serif",
  "value": "'Niramit', sans-serif"
}, {
  "name": "Nixie One",
  "category": "display",
  "value": "'Nixie One', sans-serif"
}, {
  "name": "Nobile",
  "category": "sans-serif",
  "value": "'Nobile', sans-serif"
}, {
  "name": "Nokora",
  "category": "serif",
  "value": "'Nokora', serif"
}, {
  "name": "Norican",
  "category": "handwriting",
  "value": "'Norican', cursive"
}, {
  "name": "Nosifer",
  "category": "display",
  "value": "'Nosifer', sans-serif"
}, {
  "name": "Notable",
  "category": "sans-serif",
  "value": "'Notable', sans-serif"
}, {
  "name": "Nothing You Could Do",
  "category": "handwriting",
  "value": "'Nothing You Could Do', cursive"
}, {
  "name": "Noticia Text",
  "category": "serif",
  "value": "'Noticia Text', serif"
}, {
  "name": "Noto Kufi Arabic",
  "category": "sans-serif",
  "value": "'Noto Kufi Arabic', sans-serif"
}, {
  "name": "Noto Music",
  "category": "sans-serif",
  "value": "'Noto Music', sans-serif"
}, {
  "name": "Noto Naskh Arabic",
  "category": "serif",
  "value": "'Noto Naskh Arabic', serif"
}, {
  "name": "Noto Nastaliq Urdu",
  "category": "serif",
  "value": "'Noto Nastaliq Urdu', serif"
}, {
  "name": "Noto Rashi Hebrew",
  "category": "serif",
  "value": "'Noto Rashi Hebrew', serif"
}, {
  "name": "Noto Sans",
  "category": "sans-serif",
  "value": "'Noto Sans', sans-serif"
}, {
  "name": "Noto Sans Adlam",
  "category": "sans-serif",
  "value": "'Noto Sans Adlam', sans-serif"
}, {
  "name": "Noto Sans Adlam Unjoined",
  "category": "sans-serif",
  "value": "'Noto Sans Adlam Unjoined', sans-serif"
}, {
  "name": "Noto Sans Anatolian Hieroglyphs",
  "category": "sans-serif",
  "value": "'Noto Sans Anatolian Hieroglyphs', sans-serif"
}, {
  "name": "Noto Sans Arabic",
  "category": "sans-serif",
  "value": "'Noto Sans Arabic', sans-serif"
}, {
  "name": "Noto Sans Armenian",
  "category": "sans-serif",
  "value": "'Noto Sans Armenian', sans-serif"
}, {
  "name": "Noto Sans Avestan",
  "category": "sans-serif",
  "value": "'Noto Sans Avestan', sans-serif"
}, {
  "name": "Noto Sans Balinese",
  "category": "sans-serif",
  "value": "'Noto Sans Balinese', sans-serif"
}, {
  "name": "Noto Sans Bamum",
  "category": "sans-serif",
  "value": "'Noto Sans Bamum', sans-serif"
}, {
  "name": "Noto Sans Bassa Vah",
  "category": "sans-serif",
  "value": "'Noto Sans Bassa Vah', sans-serif"
}, {
  "name": "Noto Sans Batak",
  "category": "sans-serif",
  "value": "'Noto Sans Batak', sans-serif"
}, {
  "name": "Noto Sans Bengali",
  "category": "sans-serif",
  "value": "'Noto Sans Bengali', sans-serif"
}, {
  "name": "Noto Sans Bhaiksuki",
  "category": "sans-serif",
  "value": "'Noto Sans Bhaiksuki', sans-serif"
}, {
  "name": "Noto Sans Brahmi",
  "category": "sans-serif",
  "value": "'Noto Sans Brahmi', sans-serif"
}, {
  "name": "Noto Sans Buginese",
  "category": "sans-serif",
  "value": "'Noto Sans Buginese', sans-serif"
}, {
  "name": "Noto Sans Buhid",
  "category": "sans-serif",
  "value": "'Noto Sans Buhid', sans-serif"
}, {
  "name": "Noto Sans Canadian Aboriginal",
  "category": "sans-serif",
  "value": "'Noto Sans Canadian Aboriginal', sans-serif"
}, {
  "name": "Noto Sans Carian",
  "category": "sans-serif",
  "value": "'Noto Sans Carian', sans-serif"
}, {
  "name": "Noto Sans Caucasian Albanian",
  "category": "sans-serif",
  "value": "'Noto Sans Caucasian Albanian', sans-serif"
}, {
  "name": "Noto Sans Chakma",
  "category": "sans-serif",
  "value": "'Noto Sans Chakma', sans-serif"
}, {
  "name": "Noto Sans Cham",
  "category": "sans-serif",
  "value": "'Noto Sans Cham', sans-serif"
}, {
  "name": "Noto Sans Cherokee",
  "category": "sans-serif",
  "value": "'Noto Sans Cherokee', sans-serif"
}, {
  "name": "Noto Sans Coptic",
  "category": "sans-serif",
  "value": "'Noto Sans Coptic', sans-serif"
}, {
  "name": "Noto Sans Cuneiform",
  "category": "sans-serif",
  "value": "'Noto Sans Cuneiform', sans-serif"
}, {
  "name": "Noto Sans Cypriot",
  "category": "sans-serif",
  "value": "'Noto Sans Cypriot', sans-serif"
}, {
  "name": "Noto Sans Deseret",
  "category": "sans-serif",
  "value": "'Noto Sans Deseret', sans-serif"
}, {
  "name": "Noto Sans Devanagari",
  "category": "sans-serif",
  "value": "'Noto Sans Devanagari', sans-serif"
}, {
  "name": "Noto Sans Display",
  "category": "sans-serif",
  "value": "'Noto Sans Display', sans-serif"
}, {
  "name": "Noto Sans Duployan",
  "category": "sans-serif",
  "value": "'Noto Sans Duployan', sans-serif"
}, {
  "name": "Noto Sans Egyptian Hieroglyphs",
  "category": "sans-serif",
  "value": "'Noto Sans Egyptian Hieroglyphs', sans-serif"
}, {
  "name": "Noto Sans Elbasan",
  "category": "sans-serif",
  "value": "'Noto Sans Elbasan', sans-serif"
}, {
  "name": "Noto Sans Elymaic",
  "category": "sans-serif",
  "value": "'Noto Sans Elymaic', sans-serif"
}, {
  "name": "Noto Sans Georgian",
  "category": "sans-serif",
  "value": "'Noto Sans Georgian', sans-serif"
}, {
  "name": "Noto Sans Glagolitic",
  "category": "sans-serif",
  "value": "'Noto Sans Glagolitic', sans-serif"
}, {
  "name": "Noto Sans Gothic",
  "category": "sans-serif",
  "value": "'Noto Sans Gothic', sans-serif"
}, {
  "name": "Noto Sans Grantha",
  "category": "sans-serif",
  "value": "'Noto Sans Grantha', sans-serif"
}, {
  "name": "Noto Sans Gujarati",
  "category": "sans-serif",
  "value": "'Noto Sans Gujarati', sans-serif"
}, {
  "name": "Noto Sans Gunjala Gondi",
  "category": "sans-serif",
  "value": "'Noto Sans Gunjala Gondi', sans-serif"
}, {
  "name": "Noto Sans Gurmukhi",
  "category": "sans-serif",
  "value": "'Noto Sans Gurmukhi', sans-serif"
}, {
  "name": "Noto Sans Hanifi Rohingya",
  "category": "sans-serif",
  "value": "'Noto Sans Hanifi Rohingya', sans-serif"
}, {
  "name": "Noto Sans Hanunoo",
  "category": "sans-serif",
  "value": "'Noto Sans Hanunoo', sans-serif"
}, {
  "name": "Noto Sans Hatran",
  "category": "sans-serif",
  "value": "'Noto Sans Hatran', sans-serif"
}, {
  "name": "Noto Sans Hebrew",
  "category": "sans-serif",
  "value": "'Noto Sans Hebrew', sans-serif"
}, {
  "name": "Noto Sans HK",
  "category": "sans-serif",
  "value": "'Noto Sans HK', sans-serif"
}, {
  "name": "Noto Sans Imperial Aramaic",
  "category": "sans-serif",
  "value": "'Noto Sans Imperial Aramaic', sans-serif"
}, {
  "name": "Noto Sans Indic Siyaq Numbers",
  "category": "sans-serif",
  "value": "'Noto Sans Indic Siyaq Numbers', sans-serif"
}, {
  "name": "Noto Sans Inscriptional Pahlavi",
  "category": "sans-serif",
  "value": "'Noto Sans Inscriptional Pahlavi', sans-serif"
}, {
  "name": "Noto Sans Inscriptional Parthian",
  "category": "sans-serif",
  "value": "'Noto Sans Inscriptional Parthian', sans-serif"
}, {
  "name": "Noto Sans Javanese",
  "category": "sans-serif",
  "value": "'Noto Sans Javanese', sans-serif"
}, {
  "name": "Noto Sans JP",
  "category": "sans-serif",
  "value": "'Noto Sans JP', sans-serif"
}, {
  "name": "Noto Sans Kaithi",
  "category": "sans-serif",
  "value": "'Noto Sans Kaithi', sans-serif"
}, {
  "name": "Noto Sans Kannada",
  "category": "sans-serif",
  "value": "'Noto Sans Kannada', sans-serif"
}, {
  "name": "Noto Sans Kayah Li",
  "category": "sans-serif",
  "value": "'Noto Sans Kayah Li', sans-serif"
}, {
  "name": "Noto Sans Kharoshthi",
  "category": "sans-serif",
  "value": "'Noto Sans Kharoshthi', sans-serif"
}, {
  "name": "Noto Sans Khmer",
  "category": "sans-serif",
  "value": "'Noto Sans Khmer', sans-serif"
}, {
  "name": "Noto Sans Khojki",
  "category": "sans-serif",
  "value": "'Noto Sans Khojki', sans-serif"
}, {
  "name": "Noto Sans Khudawadi",
  "category": "sans-serif",
  "value": "'Noto Sans Khudawadi', sans-serif"
}, {
  "name": "Noto Sans KR",
  "category": "sans-serif",
  "value": "'Noto Sans KR', sans-serif"
}, {
  "name": "Noto Sans Lao",
  "category": "sans-serif",
  "value": "'Noto Sans Lao', sans-serif"
}, {
  "name": "Noto Sans Lepcha",
  "category": "sans-serif",
  "value": "'Noto Sans Lepcha', sans-serif"
}, {
  "name": "Noto Sans Limbu",
  "category": "sans-serif",
  "value": "'Noto Sans Limbu', sans-serif"
}, {
  "name": "Noto Sans Linear A",
  "category": "sans-serif",
  "value": "'Noto Sans Linear A', sans-serif"
}, {
  "name": "Noto Sans Linear B",
  "category": "sans-serif",
  "value": "'Noto Sans Linear B', sans-serif"
}, {
  "name": "Noto Sans Lisu",
  "category": "sans-serif",
  "value": "'Noto Sans Lisu', sans-serif"
}, {
  "name": "Noto Sans Lycian",
  "category": "sans-serif",
  "value": "'Noto Sans Lycian', sans-serif"
}, {
  "name": "Noto Sans Lydian",
  "category": "sans-serif",
  "value": "'Noto Sans Lydian', sans-serif"
}, {
  "name": "Noto Sans Mahajani",
  "category": "sans-serif",
  "value": "'Noto Sans Mahajani', sans-serif"
}, {
  "name": "Noto Sans Malayalam",
  "category": "sans-serif",
  "value": "'Noto Sans Malayalam', sans-serif"
}, {
  "name": "Noto Sans Mandaic",
  "category": "sans-serif",
  "value": "'Noto Sans Mandaic', sans-serif"
}, {
  "name": "Noto Sans Manichaean",
  "category": "sans-serif",
  "value": "'Noto Sans Manichaean', sans-serif"
}, {
  "name": "Noto Sans Marchen",
  "category": "sans-serif",
  "value": "'Noto Sans Marchen', sans-serif"
}, {
  "name": "Noto Sans Masaram Gondi",
  "category": "sans-serif",
  "value": "'Noto Sans Masaram Gondi', sans-serif"
}, {
  "name": "Noto Sans Math",
  "category": "sans-serif",
  "value": "'Noto Sans Math', sans-serif"
}, {
  "name": "Noto Sans Mayan Numerals",
  "category": "sans-serif",
  "value": "'Noto Sans Mayan Numerals', sans-serif"
}, {
  "name": "Noto Sans Medefaidrin",
  "category": "sans-serif",
  "value": "'Noto Sans Medefaidrin', sans-serif"
}, {
  "name": "Noto Sans Meroitic",
  "category": "sans-serif",
  "value": "'Noto Sans Meroitic', sans-serif"
}, {
  "name": "Noto Sans Miao",
  "category": "sans-serif",
  "value": "'Noto Sans Miao', sans-serif"
}, {
  "name": "Noto Sans Modi",
  "category": "sans-serif",
  "value": "'Noto Sans Modi', sans-serif"
}, {
  "name": "Noto Sans Mongolian",
  "category": "sans-serif",
  "value": "'Noto Sans Mongolian', sans-serif"
}, {
  "name": "Noto Sans Mono",
  "category": "monospace",
  "value": "'Noto Sans Mono', monospace"
}, {
  "name": "Noto Sans Mro",
  "category": "sans-serif",
  "value": "'Noto Sans Mro', sans-serif"
}, {
  "name": "Noto Sans Multani",
  "category": "sans-serif",
  "value": "'Noto Sans Multani', sans-serif"
}, {
  "name": "Noto Sans Myanmar",
  "category": "sans-serif",
  "value": "'Noto Sans Myanmar', sans-serif"
}, {
  "name": "Noto Sans N Ko",
  "category": "sans-serif",
  "value": "'Noto Sans N Ko', sans-serif"
}, {
  "name": "Noto Sans Nabataean",
  "category": "sans-serif",
  "value": "'Noto Sans Nabataean', sans-serif"
}, {
  "name": "Noto Sans New Tai Lue",
  "category": "sans-serif",
  "value": "'Noto Sans New Tai Lue', sans-serif"
}, {
  "name": "Noto Sans Newa",
  "category": "sans-serif",
  "value": "'Noto Sans Newa', sans-serif"
}, {
  "name": "Noto Sans Nushu",
  "category": "sans-serif",
  "value": "'Noto Sans Nushu', sans-serif"
}, {
  "name": "Noto Sans Ogham",
  "category": "sans-serif",
  "value": "'Noto Sans Ogham', sans-serif"
}, {
  "name": "Noto Sans Ol Chiki",
  "category": "sans-serif",
  "value": "'Noto Sans Ol Chiki', sans-serif"
}, {
  "name": "Noto Sans Old Hungarian",
  "category": "sans-serif",
  "value": "'Noto Sans Old Hungarian', sans-serif"
}, {
  "name": "Noto Sans Old Italic",
  "category": "sans-serif",
  "value": "'Noto Sans Old Italic', sans-serif"
}, {
  "name": "Noto Sans Old North Arabian",
  "category": "sans-serif",
  "value": "'Noto Sans Old North Arabian', sans-serif"
}, {
  "name": "Noto Sans Old Permic",
  "category": "sans-serif",
  "value": "'Noto Sans Old Permic', sans-serif"
}, {
  "name": "Noto Sans Old Persian",
  "category": "sans-serif",
  "value": "'Noto Sans Old Persian', sans-serif"
}, {
  "name": "Noto Sans Old Sogdian",
  "category": "sans-serif",
  "value": "'Noto Sans Old Sogdian', sans-serif"
}, {
  "name": "Noto Sans Old South Arabian",
  "category": "sans-serif",
  "value": "'Noto Sans Old South Arabian', sans-serif"
}, {
  "name": "Noto Sans Old Turkic",
  "category": "sans-serif",
  "value": "'Noto Sans Old Turkic', sans-serif"
}, {
  "name": "Noto Sans Oriya",
  "category": "sans-serif",
  "value": "'Noto Sans Oriya', sans-serif"
}, {
  "name": "Noto Sans Osage",
  "category": "sans-serif",
  "value": "'Noto Sans Osage', sans-serif"
}, {
  "name": "Noto Sans Osmanya",
  "category": "sans-serif",
  "value": "'Noto Sans Osmanya', sans-serif"
}, {
  "name": "Noto Sans Pahawh Hmong",
  "category": "sans-serif",
  "value": "'Noto Sans Pahawh Hmong', sans-serif"
}, {
  "name": "Noto Sans Palmyrene",
  "category": "sans-serif",
  "value": "'Noto Sans Palmyrene', sans-serif"
}, {
  "name": "Noto Sans Pau Cin Hau",
  "category": "sans-serif",
  "value": "'Noto Sans Pau Cin Hau', sans-serif"
}, {
  "name": "Noto Sans Phags Pa",
  "category": "sans-serif",
  "value": "'Noto Sans Phags Pa', sans-serif"
}, {
  "name": "Noto Sans Phoenician",
  "category": "sans-serif",
  "value": "'Noto Sans Phoenician', sans-serif"
}, {
  "name": "Noto Sans Psalter Pahlavi",
  "category": "sans-serif",
  "value": "'Noto Sans Psalter Pahlavi', sans-serif"
}, {
  "name": "Noto Sans Rejang",
  "category": "sans-serif",
  "value": "'Noto Sans Rejang', sans-serif"
}, {
  "name": "Noto Sans Runic",
  "category": "sans-serif",
  "value": "'Noto Sans Runic', sans-serif"
}, {
  "name": "Noto Sans Samaritan",
  "category": "sans-serif",
  "value": "'Noto Sans Samaritan', sans-serif"
}, {
  "name": "Noto Sans Saurashtra",
  "category": "sans-serif",
  "value": "'Noto Sans Saurashtra', sans-serif"
}, {
  "name": "Noto Sans SC",
  "category": "sans-serif",
  "value": "'Noto Sans SC', sans-serif"
}, {
  "name": "Noto Sans Sharada",
  "category": "sans-serif",
  "value": "'Noto Sans Sharada', sans-serif"
}, {
  "name": "Noto Sans Shavian",
  "category": "sans-serif",
  "value": "'Noto Sans Shavian', sans-serif"
}, {
  "name": "Noto Sans Siddham",
  "category": "sans-serif",
  "value": "'Noto Sans Siddham', sans-serif"
}, {
  "name": "Noto Sans Sinhala",
  "category": "sans-serif",
  "value": "'Noto Sans Sinhala', sans-serif"
}, {
  "name": "Noto Sans Sogdian",
  "category": "sans-serif",
  "value": "'Noto Sans Sogdian', sans-serif"
}, {
  "name": "Noto Sans Sora Sompeng",
  "category": "sans-serif",
  "value": "'Noto Sans Sora Sompeng', sans-serif"
}, {
  "name": "Noto Sans Soyombo",
  "category": "sans-serif",
  "value": "'Noto Sans Soyombo', sans-serif"
}, {
  "name": "Noto Sans Sundanese",
  "category": "sans-serif",
  "value": "'Noto Sans Sundanese', sans-serif"
}, {
  "name": "Noto Sans Syloti Nagri",
  "category": "sans-serif",
  "value": "'Noto Sans Syloti Nagri', sans-serif"
}, {
  "name": "Noto Sans Symbols",
  "category": "sans-serif",
  "value": "'Noto Sans Symbols', sans-serif"
}, {
  "name": "Noto Sans Symbols 2",
  "category": "sans-serif",
  "value": "'Noto Sans Symbols 2', sans-serif"
}, {
  "name": "Noto Sans Syriac",
  "category": "sans-serif",
  "value": "'Noto Sans Syriac', sans-serif"
}, {
  "name": "Noto Sans Tagalog",
  "category": "sans-serif",
  "value": "'Noto Sans Tagalog', sans-serif"
}, {
  "name": "Noto Sans Tagbanwa",
  "category": "sans-serif",
  "value": "'Noto Sans Tagbanwa', sans-serif"
}, {
  "name": "Noto Sans Tai Le",
  "category": "sans-serif",
  "value": "'Noto Sans Tai Le', sans-serif"
}, {
  "name": "Noto Sans Tai Tham",
  "category": "sans-serif",
  "value": "'Noto Sans Tai Tham', sans-serif"
}, {
  "name": "Noto Sans Tai Viet",
  "category": "sans-serif",
  "value": "'Noto Sans Tai Viet', sans-serif"
}, {
  "name": "Noto Sans Takri",
  "category": "sans-serif",
  "value": "'Noto Sans Takri', sans-serif"
}, {
  "name": "Noto Sans Tamil",
  "category": "sans-serif",
  "value": "'Noto Sans Tamil', sans-serif"
}, {
  "name": "Noto Sans Tamil Supplement",
  "category": "sans-serif",
  "value": "'Noto Sans Tamil Supplement', sans-serif"
}, {
  "name": "Noto Sans TC",
  "category": "sans-serif",
  "value": "'Noto Sans TC', sans-serif"
}, {
  "name": "Noto Sans Telugu",
  "category": "sans-serif",
  "value": "'Noto Sans Telugu', sans-serif"
}, {
  "name": "Noto Sans Thaana",
  "category": "sans-serif",
  "value": "'Noto Sans Thaana', sans-serif"
}, {
  "name": "Noto Sans Thai",
  "category": "sans-serif",
  "value": "'Noto Sans Thai', sans-serif"
}, {
  "name": "Noto Sans Thai Looped",
  "category": "sans-serif",
  "value": "'Noto Sans Thai Looped', sans-serif"
}, {
  "name": "Noto Sans Tifinagh",
  "category": "sans-serif",
  "value": "'Noto Sans Tifinagh', sans-serif"
}, {
  "name": "Noto Sans Tirhuta",
  "category": "sans-serif",
  "value": "'Noto Sans Tirhuta', sans-serif"
}, {
  "name": "Noto Sans Ugaritic",
  "category": "sans-serif",
  "value": "'Noto Sans Ugaritic', sans-serif"
}, {
  "name": "Noto Sans Vai",
  "category": "sans-serif",
  "value": "'Noto Sans Vai', sans-serif"
}, {
  "name": "Noto Sans Wancho",
  "category": "sans-serif",
  "value": "'Noto Sans Wancho', sans-serif"
}, {
  "name": "Noto Sans Warang Citi",
  "category": "sans-serif",
  "value": "'Noto Sans Warang Citi', sans-serif"
}, {
  "name": "Noto Sans Yi",
  "category": "sans-serif",
  "value": "'Noto Sans Yi', sans-serif"
}, {
  "name": "Noto Sans Zanabazar Square",
  "category": "sans-serif",
  "value": "'Noto Sans Zanabazar Square', sans-serif"
}, {
  "name": "Noto Serif",
  "category": "serif",
  "value": "'Noto Serif', serif"
}, {
  "name": "Noto Serif Ahom",
  "category": "serif",
  "value": "'Noto Serif Ahom', serif"
}, {
  "name": "Noto Serif Armenian",
  "category": "serif",
  "value": "'Noto Serif Armenian', serif"
}, {
  "name": "Noto Serif Balinese",
  "category": "serif",
  "value": "'Noto Serif Balinese', serif"
}, {
  "name": "Noto Serif Bengali",
  "category": "serif",
  "value": "'Noto Serif Bengali', serif"
}, {
  "name": "Noto Serif Devanagari",
  "category": "serif",
  "value": "'Noto Serif Devanagari', serif"
}, {
  "name": "Noto Serif Display",
  "category": "serif",
  "value": "'Noto Serif Display', serif"
}, {
  "name": "Noto Serif Dogra",
  "category": "serif",
  "value": "'Noto Serif Dogra', serif"
}, {
  "name": "Noto Serif Ethiopic",
  "category": "serif",
  "value": "'Noto Serif Ethiopic', serif"
}, {
  "name": "Noto Serif Georgian",
  "category": "serif",
  "value": "'Noto Serif Georgian', serif"
}, {
  "name": "Noto Serif Grantha",
  "category": "serif",
  "value": "'Noto Serif Grantha', serif"
}, {
  "name": "Noto Serif Gujarati",
  "category": "serif",
  "value": "'Noto Serif Gujarati', serif"
}, {
  "name": "Noto Serif Gurmukhi",
  "category": "serif",
  "value": "'Noto Serif Gurmukhi', serif"
}, {
  "name": "Noto Serif Hebrew",
  "category": "serif",
  "value": "'Noto Serif Hebrew', serif"
}, {
  "name": "Noto Serif JP",
  "category": "serif",
  "value": "'Noto Serif JP', serif"
}, {
  "name": "Noto Serif Kannada",
  "category": "serif",
  "value": "'Noto Serif Kannada', serif"
}, {
  "name": "Noto Serif Khmer",
  "category": "serif",
  "value": "'Noto Serif Khmer', serif"
}, {
  "name": "Noto Serif KR",
  "category": "serif",
  "value": "'Noto Serif KR', serif"
}, {
  "name": "Noto Serif Lao",
  "category": "serif",
  "value": "'Noto Serif Lao', serif"
}, {
  "name": "Noto Serif Malayalam",
  "category": "serif",
  "value": "'Noto Serif Malayalam', serif"
}, {
  "name": "Noto Serif Myanmar",
  "category": "serif",
  "value": "'Noto Serif Myanmar', serif"
}, {
  "name": "Noto Serif Nyiakeng Puachue Hmong",
  "category": "serif",
  "value": "'Noto Serif Nyiakeng Puachue Hmong', serif"
}, {
  "name": "Noto Serif SC",
  "category": "serif",
  "value": "'Noto Serif SC', serif"
}, {
  "name": "Noto Serif Sinhala",
  "category": "serif",
  "value": "'Noto Serif Sinhala', serif"
}, {
  "name": "Noto Serif Tamil",
  "category": "serif",
  "value": "'Noto Serif Tamil', serif"
}, {
  "name": "Noto Serif Tangut",
  "category": "serif",
  "value": "'Noto Serif Tangut', serif"
}, {
  "name": "Noto Serif TC",
  "category": "serif",
  "value": "'Noto Serif TC', serif"
}, {
  "name": "Noto Serif Telugu",
  "category": "serif",
  "value": "'Noto Serif Telugu', serif"
}, {
  "name": "Noto Serif Thai",
  "category": "serif",
  "value": "'Noto Serif Thai', serif"
}, {
  "name": "Noto Serif Tibetan",
  "category": "serif",
  "value": "'Noto Serif Tibetan', serif"
}, {
  "name": "Noto Serif Yezidi",
  "category": "serif",
  "value": "'Noto Serif Yezidi', serif"
}, {
  "name": "Noto Traditional Nushu",
  "category": "sans-serif",
  "value": "'Noto Traditional Nushu', sans-serif"
}, {
  "name": "Nova Cut",
  "category": "display",
  "value": "'Nova Cut', sans-serif"
}, {
  "name": "Nova Flat",
  "category": "display",
  "value": "'Nova Flat', sans-serif"
}, {
  "name": "Nova Mono",
  "category": "monospace",
  "value": "'Nova Mono', monospace"
}, {
  "name": "Nova Oval",
  "category": "display",
  "value": "'Nova Oval', sans-serif"
}, {
  "name": "Nova Round",
  "category": "display",
  "value": "'Nova Round', sans-serif"
}, {
  "name": "Nova Script",
  "category": "display",
  "value": "'Nova Script', sans-serif"
}, {
  "name": "Nova Slim",
  "category": "display",
  "value": "'Nova Slim', sans-serif"
}, {
  "name": "Nova Square",
  "category": "display",
  "value": "'Nova Square', sans-serif"
}, {
  "name": "NTR",
  "category": "sans-serif",
  "value": "'NTR', sans-serif"
}, {
  "name": "Numans",
  "category": "sans-serif",
  "value": "'Numans', sans-serif"
}, {
  "name": "Nunito",
  "category": "sans-serif",
  "value": "'Nunito', sans-serif"
}, {
  "name": "Nunito Sans",
  "category": "sans-serif",
  "value": "'Nunito Sans', sans-serif"
}, {
  "name": "Odibee Sans",
  "category": "display",
  "value": "'Odibee Sans', sans-serif"
}, {
  "name": "Odor Mean Chey",
  "category": "serif",
  "value": "'Odor Mean Chey', serif"
}, {
  "name": "Offside",
  "category": "display",
  "value": "'Offside', sans-serif"
}, {
  "name": "Oi",
  "category": "display",
  "value": "'Oi', sans-serif"
}, {
  "name": "Old Standard TT",
  "category": "serif",
  "value": "'Old Standard TT', serif"
}, {
  "name": "Oldenburg",
  "category": "display",
  "value": "'Oldenburg', sans-serif"
}, {
  "name": "Oleo Script",
  "category": "display",
  "value": "'Oleo Script', sans-serif"
}, {
  "name": "Oleo Script Swash Caps",
  "category": "display",
  "value": "'Oleo Script Swash Caps', sans-serif"
}, {
  "name": "Open Sans",
  "category": "sans-serif",
  "value": "'Open Sans', sans-serif"
}, {
  "name": "Open Sans Condensed",
  "category": "sans-serif",
  "value": "'Open Sans Condensed', sans-serif"
}, {
  "name": "Oranienbaum",
  "category": "serif",
  "value": "'Oranienbaum', serif"
}, {
  "name": "Orbitron",
  "category": "sans-serif",
  "value": "'Orbitron', sans-serif"
}, {
  "name": "Oregano",
  "category": "display",
  "value": "'Oregano', sans-serif"
}, {
  "name": "Orelega One",
  "category": "display",
  "value": "'Orelega One', sans-serif"
}, {
  "name": "Orienta",
  "category": "sans-serif",
  "value": "'Orienta', sans-serif"
}, {
  "name": "Original Surfer",
  "category": "display",
  "value": "'Original Surfer', sans-serif"
}, {
  "name": "Oswald",
  "category": "sans-serif",
  "value": "'Oswald', sans-serif"
}, {
  "name": "Otomanopee One",
  "category": "sans-serif",
  "value": "'Otomanopee One', sans-serif"
}, {
  "name": "Over the Rainbow",
  "category": "handwriting",
  "value": "'Over the Rainbow', cursive"
}, {
  "name": "Overlock",
  "category": "display",
  "value": "'Overlock', sans-serif"
}, {
  "name": "Overlock SC",
  "category": "display",
  "value": "'Overlock SC', sans-serif"
}, {
  "name": "Overpass",
  "category": "sans-serif",
  "value": "'Overpass', sans-serif"
}, {
  "name": "Overpass Mono",
  "category": "monospace",
  "value": "'Overpass Mono', monospace"
}, {
  "name": "Ovo",
  "category": "serif",
  "value": "'Ovo', serif"
}, {
  "name": "Oxanium",
  "category": "display",
  "value": "'Oxanium', sans-serif"
}, {
  "name": "Oxygen",
  "category": "sans-serif",
  "value": "'Oxygen', sans-serif"
}, {
  "name": "Oxygen Mono",
  "category": "monospace",
  "value": "'Oxygen Mono', monospace"
}, {
  "name": "Pacifico",
  "category": "handwriting",
  "value": "'Pacifico', cursive"
}, {
  "name": "Padauk",
  "category": "sans-serif",
  "value": "'Padauk', sans-serif"
}, {
  "name": "Palanquin",
  "category": "sans-serif",
  "value": "'Palanquin', sans-serif"
}, {
  "name": "Palanquin Dark",
  "category": "sans-serif",
  "value": "'Palanquin Dark', sans-serif"
}, {
  "name": "Palette Mosaic",
  "category": "display",
  "value": "'Palette Mosaic', sans-serif"
}, {
  "name": "Pangolin",
  "category": "handwriting",
  "value": "'Pangolin', cursive"
}, {
  "name": "Paprika",
  "category": "display",
  "value": "'Paprika', sans-serif"
}, {
  "name": "Parisienne",
  "category": "handwriting",
  "value": "'Parisienne', cursive"
}, {
  "name": "Passero One",
  "category": "display",
  "value": "'Passero One', sans-serif"
}, {
  "name": "Passion One",
  "category": "display",
  "value": "'Passion One', sans-serif"
}, {
  "name": "Pathway Gothic One",
  "category": "sans-serif",
  "value": "'Pathway Gothic One', sans-serif"
}, {
  "name": "Patrick Hand",
  "category": "handwriting",
  "value": "'Patrick Hand', cursive"
}, {
  "name": "Patrick Hand SC",
  "category": "handwriting",
  "value": "'Patrick Hand SC', cursive"
}, {
  "name": "Pattaya",
  "category": "sans-serif",
  "value": "'Pattaya', sans-serif"
}, {
  "name": "Patua One",
  "category": "display",
  "value": "'Patua One', sans-serif"
}, {
  "name": "Pavanam",
  "category": "sans-serif",
  "value": "'Pavanam', sans-serif"
}, {
  "name": "Paytone One",
  "category": "sans-serif",
  "value": "'Paytone One', sans-serif"
}, {
  "name": "Peddana",
  "category": "serif",
  "value": "'Peddana', serif"
}, {
  "name": "Peralta",
  "category": "display",
  "value": "'Peralta', sans-serif"
}, {
  "name": "Permanent Marker",
  "category": "handwriting",
  "value": "'Permanent Marker', cursive"
}, {
  "name": "Petit Formal Script",
  "category": "handwriting",
  "value": "'Petit Formal Script', cursive"
}, {
  "name": "Petrona",
  "category": "serif",
  "value": "'Petrona', serif"
}, {
  "name": "Philosopher",
  "category": "sans-serif",
  "value": "'Philosopher', sans-serif"
}, {
  "name": "Piazzolla",
  "category": "serif",
  "value": "'Piazzolla', serif"
}, {
  "name": "Piedra",
  "category": "display",
  "value": "'Piedra', sans-serif"
}, {
  "name": "Pinyon Script",
  "category": "handwriting",
  "value": "'Pinyon Script', cursive"
}, {
  "name": "Pirata One",
  "category": "display",
  "value": "'Pirata One', sans-serif"
}, {
  "name": "Plaster",
  "category": "display",
  "value": "'Plaster', sans-serif"
}, {
  "name": "Play",
  "category": "sans-serif",
  "value": "'Play', sans-serif"
}, {
  "name": "Playball",
  "category": "display",
  "value": "'Playball', sans-serif"
}, {
  "name": "Playfair Display",
  "category": "serif",
  "value": "'Playfair Display', serif"
}, {
  "name": "Playfair Display SC",
  "category": "serif",
  "value": "'Playfair Display SC', serif"
}, {
  "name": "Podkova",
  "category": "serif",
  "value": "'Podkova', serif"
}, {
  "name": "Poiret One",
  "category": "display",
  "value": "'Poiret One', sans-serif"
}, {
  "name": "Poller One",
  "category": "display",
  "value": "'Poller One', sans-serif"
}, {
  "name": "Poly",
  "category": "serif",
  "value": "'Poly', serif"
}, {
  "name": "Pompiere",
  "category": "display",
  "value": "'Pompiere', sans-serif"
}, {
  "name": "Pontano Sans",
  "category": "sans-serif",
  "value": "'Pontano Sans', sans-serif"
}, {
  "name": "Poor Story",
  "category": "display",
  "value": "'Poor Story', sans-serif"
}, {
  "name": "Poppins",
  "category": "sans-serif",
  "value": "'Poppins', sans-serif"
}, {
  "name": "Port Lligat Sans",
  "category": "sans-serif",
  "value": "'Port Lligat Sans', sans-serif"
}, {
  "name": "Port Lligat Slab",
  "category": "serif",
  "value": "'Port Lligat Slab', serif"
}, {
  "name": "Potta One",
  "category": "display",
  "value": "'Potta One', sans-serif"
}, {
  "name": "Pragati Narrow",
  "category": "sans-serif",
  "value": "'Pragati Narrow', sans-serif"
}, {
  "name": "Prata",
  "category": "serif",
  "value": "'Prata', serif"
}, {
  "name": "Preahvihear",
  "category": "sans-serif",
  "value": "'Preahvihear', sans-serif"
}, {
  "name": "Press Start 2P",
  "category": "display",
  "value": "'Press Start 2P', sans-serif"
}, {
  "name": "Pridi",
  "category": "serif",
  "value": "'Pridi', serif"
}, {
  "name": "Princess Sofia",
  "category": "handwriting",
  "value": "'Princess Sofia', cursive"
}, {
  "name": "Prociono",
  "category": "serif",
  "value": "'Prociono', serif"
}, {
  "name": "Prompt",
  "category": "sans-serif",
  "value": "'Prompt', sans-serif"
}, {
  "name": "Prosto One",
  "category": "display",
  "value": "'Prosto One', sans-serif"
}, {
  "name": "Proza Libre",
  "category": "sans-serif",
  "value": "'Proza Libre', sans-serif"
}, {
  "name": "PT Mono",
  "category": "monospace",
  "value": "'PT Mono', monospace"
}, {
  "name": "PT Sans",
  "category": "sans-serif",
  "value": "'PT Sans', sans-serif"
}, {
  "name": "PT Sans Caption",
  "category": "sans-serif",
  "value": "'PT Sans Caption', sans-serif"
}, {
  "name": "PT Sans Narrow",
  "category": "sans-serif",
  "value": "'PT Sans Narrow', sans-serif"
}, {
  "name": "PT Serif",
  "category": "serif",
  "value": "'PT Serif', serif"
}, {
  "name": "PT Serif Caption",
  "category": "serif",
  "value": "'PT Serif Caption', serif"
}, {
  "name": "Public Sans",
  "category": "sans-serif",
  "value": "'Public Sans', sans-serif"
}, {
  "name": "Puritan",
  "category": "sans-serif",
  "value": "'Puritan', sans-serif"
}, {
  "name": "Purple Purse",
  "category": "display",
  "value": "'Purple Purse', sans-serif"
}, {
  "name": "Qahiri",
  "category": "sans-serif",
  "value": "'Qahiri', sans-serif"
}, {
  "name": "Quando",
  "category": "serif",
  "value": "'Quando', serif"
}, {
  "name": "Quantico",
  "category": "sans-serif",
  "value": "'Quantico', sans-serif"
}, {
  "name": "Quattrocento",
  "category": "serif",
  "value": "'Quattrocento', serif"
}, {
  "name": "Quattrocento Sans",
  "category": "sans-serif",
  "value": "'Quattrocento Sans', sans-serif"
}, {
  "name": "Questrial",
  "category": "sans-serif",
  "value": "'Questrial', sans-serif"
}, {
  "name": "Quicksand",
  "category": "sans-serif",
  "value": "'Quicksand', sans-serif"
}, {
  "name": "Quintessential",
  "category": "handwriting",
  "value": "'Quintessential', cursive"
}, {
  "name": "Qwigley",
  "category": "handwriting",
  "value": "'Qwigley', cursive"
}, {
  "name": "Racing Sans One",
  "category": "display",
  "value": "'Racing Sans One', sans-serif"
}, {
  "name": "Radley",
  "category": "serif",
  "value": "'Radley', serif"
}, {
  "name": "Rajdhani",
  "category": "sans-serif",
  "value": "'Rajdhani', sans-serif"
}, {
  "name": "Rakkas",
  "category": "display",
  "value": "'Rakkas', sans-serif"
}, {
  "name": "Raleway",
  "category": "sans-serif",
  "value": "'Raleway', sans-serif"
}, {
  "name": "Raleway Dots",
  "category": "display",
  "value": "'Raleway Dots', sans-serif"
}, {
  "name": "Ramabhadra",
  "category": "sans-serif",
  "value": "'Ramabhadra', sans-serif"
}, {
  "name": "Ramaraja",
  "category": "serif",
  "value": "'Ramaraja', serif"
}, {
  "name": "Rambla",
  "category": "sans-serif",
  "value": "'Rambla', sans-serif"
}, {
  "name": "Rammetto One",
  "category": "display",
  "value": "'Rammetto One', sans-serif"
}, {
  "name": "Rampart One",
  "category": "display",
  "value": "'Rampart One', sans-serif"
}, {
  "name": "Ranchers",
  "category": "display",
  "value": "'Ranchers', sans-serif"
}, {
  "name": "Rancho",
  "category": "handwriting",
  "value": "'Rancho', cursive"
}, {
  "name": "Ranga",
  "category": "display",
  "value": "'Ranga', sans-serif"
}, {
  "name": "Rasa",
  "category": "serif",
  "value": "'Rasa', serif"
}, {
  "name": "Rationale",
  "category": "sans-serif",
  "value": "'Rationale', sans-serif"
}, {
  "name": "Ravi Prakash",
  "category": "display",
  "value": "'Ravi Prakash', sans-serif"
}, {
  "name": "Recursive",
  "category": "sans-serif",
  "value": "'Recursive', sans-serif"
}, {
  "name": "Red Hat Display",
  "category": "sans-serif",
  "value": "'Red Hat Display', sans-serif"
}, {
  "name": "Red Hat Text",
  "category": "sans-serif",
  "value": "'Red Hat Text', sans-serif"
}, {
  "name": "Red Rose",
  "category": "display",
  "value": "'Red Rose', sans-serif"
}, {
  "name": "Redressed",
  "category": "handwriting",
  "value": "'Redressed', cursive"
}, {
  "name": "Reem Kufi",
  "category": "sans-serif",
  "value": "'Reem Kufi', sans-serif"
}, {
  "name": "Reenie Beanie",
  "category": "handwriting",
  "value": "'Reenie Beanie', cursive"
}, {
  "name": "Reggae One",
  "category": "display",
  "value": "'Reggae One', sans-serif"
}, {
  "name": "Revalia",
  "category": "display",
  "value": "'Revalia', sans-serif"
}, {
  "name": "Rhodium Libre",
  "category": "serif",
  "value": "'Rhodium Libre', serif"
}, {
  "name": "Ribeye",
  "category": "display",
  "value": "'Ribeye', sans-serif"
}, {
  "name": "Ribeye Marrow",
  "category": "display",
  "value": "'Ribeye Marrow', sans-serif"
}, {
  "name": "Righteous",
  "category": "display",
  "value": "'Righteous', sans-serif"
}, {
  "name": "Risque",
  "category": "display",
  "value": "'Risque', sans-serif"
}, {
  "name": "Roboto",
  "category": "sans-serif",
  "value": "'Roboto', sans-serif"
}, {
  "name": "Roboto Condensed",
  "category": "sans-serif",
  "value": "'Roboto Condensed', sans-serif"
}, {
  "name": "Roboto Mono",
  "category": "monospace",
  "value": "'Roboto Mono', monospace"
}, {
  "name": "Roboto Slab",
  "category": "serif",
  "value": "'Roboto Slab', serif"
}, {
  "name": "Rochester",
  "category": "handwriting",
  "value": "'Rochester', cursive"
}, {
  "name": "Rock Salt",
  "category": "handwriting",
  "value": "'Rock Salt', cursive"
}, {
  "name": "RocknRoll One",
  "category": "sans-serif",
  "value": "'RocknRoll One', sans-serif"
}, {
  "name": "Rokkitt",
  "category": "serif",
  "value": "'Rokkitt', serif"
}, {
  "name": "Romanesco",
  "category": "handwriting",
  "value": "'Romanesco', cursive"
}, {
  "name": "Ropa Sans",
  "category": "sans-serif",
  "value": "'Ropa Sans', sans-serif"
}, {
  "name": "Rosario",
  "category": "sans-serif",
  "value": "'Rosario', sans-serif"
}, {
  "name": "Rosarivo",
  "category": "serif",
  "value": "'Rosarivo', serif"
}, {
  "name": "Rouge Script",
  "category": "handwriting",
  "value": "'Rouge Script', cursive"
}, {
  "name": "Rowdies",
  "category": "display",
  "value": "'Rowdies', sans-serif"
}, {
  "name": "Rozha One",
  "category": "serif",
  "value": "'Rozha One', serif"
}, {
  "name": "Rubik",
  "category": "sans-serif",
  "value": "'Rubik', sans-serif"
}, {
  "name": "Rubik Beastly",
  "category": "display",
  "value": "'Rubik Beastly', sans-serif"
}, {
  "name": "Rubik Mono One",
  "category": "sans-serif",
  "value": "'Rubik Mono One', sans-serif"
}, {
  "name": "Ruda",
  "category": "sans-serif",
  "value": "'Ruda', sans-serif"
}, {
  "name": "Rufina",
  "category": "serif",
  "value": "'Rufina', serif"
}, {
  "name": "Ruge Boogie",
  "category": "handwriting",
  "value": "'Ruge Boogie', cursive"
}, {
  "name": "Ruluko",
  "category": "sans-serif",
  "value": "'Ruluko', sans-serif"
}, {
  "name": "Rum Raisin",
  "category": "sans-serif",
  "value": "'Rum Raisin', sans-serif"
}, {
  "name": "Ruslan Display",
  "category": "display",
  "value": "'Ruslan Display', sans-serif"
}, {
  "name": "Russo One",
  "category": "sans-serif",
  "value": "'Russo One', sans-serif"
}, {
  "name": "Ruthie",
  "category": "handwriting",
  "value": "'Ruthie', cursive"
}, {
  "name": "Rye",
  "category": "display",
  "value": "'Rye', sans-serif"
}, {
  "name": "Sacramento",
  "category": "handwriting",
  "value": "'Sacramento', cursive"
}, {
  "name": "Sahitya",
  "category": "serif",
  "value": "'Sahitya', serif"
}, {
  "name": "Sail",
  "category": "display",
  "value": "'Sail', sans-serif"
}, {
  "name": "Saira",
  "category": "sans-serif",
  "value": "'Saira', sans-serif"
}, {
  "name": "Saira Condensed",
  "category": "sans-serif",
  "value": "'Saira Condensed', sans-serif"
}, {
  "name": "Saira Extra Condensed",
  "category": "sans-serif",
  "value": "'Saira Extra Condensed', sans-serif"
}, {
  "name": "Saira Semi Condensed",
  "category": "sans-serif",
  "value": "'Saira Semi Condensed', sans-serif"
}, {
  "name": "Saira Stencil One",
  "category": "display",
  "value": "'Saira Stencil One', sans-serif"
}, {
  "name": "Salsa",
  "category": "display",
  "value": "'Salsa', sans-serif"
}, {
  "name": "Sanchez",
  "category": "serif",
  "value": "'Sanchez', serif"
}, {
  "name": "Sancreek",
  "category": "display",
  "value": "'Sancreek', sans-serif"
}, {
  "name": "Sansita",
  "category": "sans-serif",
  "value": "'Sansita', sans-serif"
}, {
  "name": "Sansita Swashed",
  "category": "display",
  "value": "'Sansita Swashed', sans-serif"
}, {
  "name": "Sarabun",
  "category": "sans-serif",
  "value": "'Sarabun', sans-serif"
}, {
  "name": "Sarala",
  "category": "sans-serif",
  "value": "'Sarala', sans-serif"
}, {
  "name": "Sarina",
  "category": "display",
  "value": "'Sarina', sans-serif"
}, {
  "name": "Sarpanch",
  "category": "sans-serif",
  "value": "'Sarpanch', sans-serif"
}, {
  "name": "Satisfy",
  "category": "handwriting",
  "value": "'Satisfy', cursive"
}, {
  "name": "Sawarabi Gothic",
  "category": "sans-serif",
  "value": "'Sawarabi Gothic', sans-serif"
}, {
  "name": "Sawarabi Mincho",
  "category": "sans-serif",
  "value": "'Sawarabi Mincho', sans-serif"
}, {
  "name": "Scada",
  "category": "sans-serif",
  "value": "'Scada', sans-serif"
}, {
  "name": "Scheherazade",
  "category": "serif",
  "value": "'Scheherazade', serif"
}, {
  "name": "Scheherazade New",
  "category": "serif",
  "value": "'Scheherazade New', serif"
}, {
  "name": "Schoolbell",
  "category": "handwriting",
  "value": "'Schoolbell', cursive"
}, {
  "name": "Scope One",
  "category": "serif",
  "value": "'Scope One', serif"
}, {
  "name": "Seaweed Script",
  "category": "display",
  "value": "'Seaweed Script', sans-serif"
}, {
  "name": "Secular One",
  "category": "sans-serif",
  "value": "'Secular One', sans-serif"
}, {
  "name": "Sedgwick Ave",
  "category": "handwriting",
  "value": "'Sedgwick Ave', cursive"
}, {
  "name": "Sedgwick Ave Display",
  "category": "handwriting",
  "value": "'Sedgwick Ave Display', cursive"
}, {
  "name": "Sen",
  "category": "sans-serif",
  "value": "'Sen', sans-serif"
}, {
  "name": "Sevillana",
  "category": "display",
  "value": "'Sevillana', sans-serif"
}, {
  "name": "Seymour One",
  "category": "sans-serif",
  "value": "'Seymour One', sans-serif"
}, {
  "name": "Shadows Into Light",
  "category": "handwriting",
  "value": "'Shadows Into Light', cursive"
}, {
  "name": "Shadows Into Light Two",
  "category": "handwriting",
  "value": "'Shadows Into Light Two', cursive"
}, {
  "name": "Shanti",
  "category": "sans-serif",
  "value": "'Shanti', sans-serif"
}, {
  "name": "Share",
  "category": "display",
  "value": "'Share', sans-serif"
}, {
  "name": "Share Tech",
  "category": "sans-serif",
  "value": "'Share Tech', sans-serif"
}, {
  "name": "Share Tech Mono",
  "category": "monospace",
  "value": "'Share Tech Mono', monospace"
}, {
  "name": "Shippori Mincho",
  "category": "serif",
  "value": "'Shippori Mincho', serif"
}, {
  "name": "Shippori Mincho B1",
  "category": "serif",
  "value": "'Shippori Mincho B1', serif"
}, {
  "name": "Shojumaru",
  "category": "display",
  "value": "'Shojumaru', sans-serif"
}, {
  "name": "Short Stack",
  "category": "handwriting",
  "value": "'Short Stack', cursive"
}, {
  "name": "Shrikhand",
  "category": "display",
  "value": "'Shrikhand', sans-serif"
}, {
  "name": "Siemreap",
  "category": "display",
  "value": "'Siemreap', sans-serif"
}, {
  "name": "Sigmar One",
  "category": "display",
  "value": "'Sigmar One', sans-serif"
}, {
  "name": "Signika",
  "category": "sans-serif",
  "value": "'Signika', sans-serif"
}, {
  "name": "Signika Negative",
  "category": "sans-serif",
  "value": "'Signika Negative', sans-serif"
}, {
  "name": "Simonetta",
  "category": "display",
  "value": "'Simonetta', sans-serif"
}, {
  "name": "Single Day",
  "category": "display",
  "value": "'Single Day', sans-serif"
}, {
  "name": "Sintony",
  "category": "sans-serif",
  "value": "'Sintony', sans-serif"
}, {
  "name": "Sirin Stencil",
  "category": "display",
  "value": "'Sirin Stencil', sans-serif"
}, {
  "name": "Six Caps",
  "category": "sans-serif",
  "value": "'Six Caps', sans-serif"
}, {
  "name": "Skranji",
  "category": "display",
  "value": "'Skranji', sans-serif"
}, {
  "name": "Slabo 13px",
  "category": "serif",
  "value": "'Slabo 13px', serif"
}, {
  "name": "Slabo 27px",
  "category": "serif",
  "value": "'Slabo 27px', serif"
}, {
  "name": "Slackey",
  "category": "display",
  "value": "'Slackey', sans-serif"
}, {
  "name": "Smokum",
  "category": "display",
  "value": "'Smokum', sans-serif"
}, {
  "name": "Smythe",
  "category": "display",
  "value": "'Smythe', sans-serif"
}, {
  "name": "Sniglet",
  "category": "display",
  "value": "'Sniglet', sans-serif"
}, {
  "name": "Snippet",
  "category": "sans-serif",
  "value": "'Snippet', sans-serif"
}, {
  "name": "Snowburst One",
  "category": "display",
  "value": "'Snowburst One', sans-serif"
}, {
  "name": "Sofadi One",
  "category": "display",
  "value": "'Sofadi One', sans-serif"
}, {
  "name": "Sofia",
  "category": "handwriting",
  "value": "'Sofia', cursive"
}, {
  "name": "Solway",
  "category": "serif",
  "value": "'Solway', serif"
}, {
  "name": "Song Myung",
  "category": "serif",
  "value": "'Song Myung', serif"
}, {
  "name": "Sonsie One",
  "category": "display",
  "value": "'Sonsie One', sans-serif"
}, {
  "name": "Sora",
  "category": "sans-serif",
  "value": "'Sora', sans-serif"
}, {
  "name": "Sorts Mill Goudy",
  "category": "serif",
  "value": "'Sorts Mill Goudy', serif"
}, {
  "name": "Source Code Pro",
  "category": "monospace",
  "value": "'Source Code Pro', monospace"
}, {
  "name": "Source Sans Pro",
  "category": "sans-serif",
  "value": "'Source Sans Pro', sans-serif"
}, {
  "name": "Source Serif Pro",
  "category": "serif",
  "value": "'Source Serif Pro', serif"
}, {
  "name": "Space Grotesk",
  "category": "sans-serif",
  "value": "'Space Grotesk', sans-serif"
}, {
  "name": "Space Mono",
  "category": "monospace",
  "value": "'Space Mono', monospace"
}, {
  "name": "Spartan",
  "category": "sans-serif",
  "value": "'Spartan', sans-serif"
}, {
  "name": "Special Elite",
  "category": "display",
  "value": "'Special Elite', sans-serif"
}, {
  "name": "Spectral",
  "category": "serif",
  "value": "'Spectral', serif"
}, {
  "name": "Spectral SC",
  "category": "serif",
  "value": "'Spectral SC', serif"
}, {
  "name": "Spicy Rice",
  "category": "display",
  "value": "'Spicy Rice', sans-serif"
}, {
  "name": "Spinnaker",
  "category": "sans-serif",
  "value": "'Spinnaker', sans-serif"
}, {
  "name": "Spirax",
  "category": "display",
  "value": "'Spirax', sans-serif"
}, {
  "name": "Squada One",
  "category": "display",
  "value": "'Squada One', sans-serif"
}, {
  "name": "Sree Krushnadevaraya",
  "category": "serif",
  "value": "'Sree Krushnadevaraya', serif"
}, {
  "name": "Sriracha",
  "category": "handwriting",
  "value": "'Sriracha', cursive"
}, {
  "name": "Srisakdi",
  "category": "display",
  "value": "'Srisakdi', sans-serif"
}, {
  "name": "Staatliches",
  "category": "display",
  "value": "'Staatliches', sans-serif"
}, {
  "name": "Stalemate",
  "category": "handwriting",
  "value": "'Stalemate', cursive"
}, {
  "name": "Stalinist One",
  "category": "display",
  "value": "'Stalinist One', sans-serif"
}, {
  "name": "Stardos Stencil",
  "category": "display",
  "value": "'Stardos Stencil', sans-serif"
}, {
  "name": "Stick",
  "category": "sans-serif",
  "value": "'Stick', sans-serif"
}, {
  "name": "Stick No Bills",
  "category": "sans-serif",
  "value": "'Stick No Bills', sans-serif"
}, {
  "name": "Stint Ultra Condensed",
  "category": "display",
  "value": "'Stint Ultra Condensed', sans-serif"
}, {
  "name": "Stint Ultra Expanded",
  "category": "display",
  "value": "'Stint Ultra Expanded', sans-serif"
}, {
  "name": "STIX Two Text",
  "category": "serif",
  "value": "'STIX Two Text', serif"
}, {
  "name": "Stoke",
  "category": "serif",
  "value": "'Stoke', serif"
}, {
  "name": "Strait",
  "category": "sans-serif",
  "value": "'Strait', sans-serif"
}, {
  "name": "Style Script",
  "category": "handwriting",
  "value": "'Style Script', cursive"
}, {
  "name": "Stylish",
  "category": "sans-serif",
  "value": "'Stylish', sans-serif"
}, {
  "name": "Sue Ellen Francisco",
  "category": "handwriting",
  "value": "'Sue Ellen Francisco', cursive"
}, {
  "name": "Suez One",
  "category": "serif",
  "value": "'Suez One', serif"
}, {
  "name": "Sulphur Point",
  "category": "sans-serif",
  "value": "'Sulphur Point', sans-serif"
}, {
  "name": "Sumana",
  "category": "serif",
  "value": "'Sumana', serif"
}, {
  "name": "Sunflower",
  "category": "sans-serif",
  "value": "'Sunflower', sans-serif"
}, {
  "name": "Sunshiney",
  "category": "handwriting",
  "value": "'Sunshiney', cursive"
}, {
  "name": "Supermercado One",
  "category": "display",
  "value": "'Supermercado One', sans-serif"
}, {
  "name": "Sura",
  "category": "serif",
  "value": "'Sura', serif"
}, {
  "name": "Suranna",
  "category": "serif",
  "value": "'Suranna', serif"
}, {
  "name": "Suravaram",
  "category": "serif",
  "value": "'Suravaram', serif"
}, {
  "name": "Suwannaphum",
  "category": "serif",
  "value": "'Suwannaphum', serif"
}, {
  "name": "Swanky and Moo Moo",
  "category": "handwriting",
  "value": "'Swanky and Moo Moo', cursive"
}, {
  "name": "Syncopate",
  "category": "sans-serif",
  "value": "'Syncopate', sans-serif"
}, {
  "name": "Syne",
  "category": "sans-serif",
  "value": "'Syne', sans-serif"
}, {
  "name": "Syne Mono",
  "category": "monospace",
  "value": "'Syne Mono', monospace"
}, {
  "name": "Syne Tactile",
  "category": "display",
  "value": "'Syne Tactile', sans-serif"
}, {
  "name": "Tajawal",
  "category": "sans-serif",
  "value": "'Tajawal', sans-serif"
}, {
  "name": "Tangerine",
  "category": "handwriting",
  "value": "'Tangerine', cursive"
}, {
  "name": "Taprom",
  "category": "display",
  "value": "'Taprom', sans-serif"
}, {
  "name": "Tauri",
  "category": "sans-serif",
  "value": "'Tauri', sans-serif"
}, {
  "name": "Taviraj",
  "category": "serif",
  "value": "'Taviraj', serif"
}, {
  "name": "Teko",
  "category": "sans-serif",
  "value": "'Teko', sans-serif"
}, {
  "name": "Telex",
  "category": "sans-serif",
  "value": "'Telex', sans-serif"
}, {
  "name": "Tenali Ramakrishna",
  "category": "sans-serif",
  "value": "'Tenali Ramakrishna', sans-serif"
}, {
  "name": "Tenor Sans",
  "category": "sans-serif",
  "value": "'Tenor Sans', sans-serif"
}, {
  "name": "Text Me One",
  "category": "sans-serif",
  "value": "'Text Me One', sans-serif"
}, {
  "name": "Texturina",
  "category": "serif",
  "value": "'Texturina', serif"
}, {
  "name": "Thasadith",
  "category": "sans-serif",
  "value": "'Thasadith', sans-serif"
}, {
  "name": "The Girl Next Door",
  "category": "handwriting",
  "value": "'The Girl Next Door', cursive"
}, {
  "name": "Tienne",
  "category": "serif",
  "value": "'Tienne', serif"
}, {
  "name": "Tillana",
  "category": "handwriting",
  "value": "'Tillana', cursive"
}, {
  "name": "Timmana",
  "category": "sans-serif",
  "value": "'Timmana', sans-serif"
}, {
  "name": "Tinos",
  "category": "serif",
  "value": "'Tinos', serif"
}, {
  "name": "Titan One",
  "category": "display",
  "value": "'Titan One', sans-serif"
}, {
  "name": "Titillium Web",
  "category": "sans-serif",
  "value": "'Titillium Web', sans-serif"
}, {
  "name": "Tomorrow",
  "category": "sans-serif",
  "value": "'Tomorrow', sans-serif"
}, {
  "name": "Tourney",
  "category": "display",
  "value": "'Tourney', sans-serif"
}, {
  "name": "Trade Winds",
  "category": "display",
  "value": "'Trade Winds', sans-serif"
}, {
  "name": "Train One",
  "category": "display",
  "value": "'Train One', sans-serif"
}, {
  "name": "Trirong",
  "category": "serif",
  "value": "'Trirong', serif"
}, {
  "name": "Trispace",
  "category": "sans-serif",
  "value": "'Trispace', sans-serif"
}, {
  "name": "Trocchi",
  "category": "serif",
  "value": "'Trocchi', serif"
}, {
  "name": "Trochut",
  "category": "display",
  "value": "'Trochut', sans-serif"
}, {
  "name": "Truculenta",
  "category": "sans-serif",
  "value": "'Truculenta', sans-serif"
}, {
  "name": "Trykker",
  "category": "serif",
  "value": "'Trykker', serif"
}, {
  "name": "Tulpen One",
  "category": "display",
  "value": "'Tulpen One', sans-serif"
}, {
  "name": "Turret Road",
  "category": "display",
  "value": "'Turret Road', sans-serif"
}, {
  "name": "Ubuntu",
  "category": "sans-serif",
  "value": "'Ubuntu', sans-serif"
}, {
  "name": "Ubuntu Condensed",
  "category": "sans-serif",
  "value": "'Ubuntu Condensed', sans-serif"
}, {
  "name": "Ubuntu Mono",
  "category": "monospace",
  "value": "'Ubuntu Mono', monospace"
}, {
  "name": "Uchen",
  "category": "serif",
  "value": "'Uchen', serif"
}, {
  "name": "Ultra",
  "category": "serif",
  "value": "'Ultra', serif"
}, {
  "name": "Uncial Antiqua",
  "category": "display",
  "value": "'Uncial Antiqua', sans-serif"
}, {
  "name": "Underdog",
  "category": "display",
  "value": "'Underdog', sans-serif"
}, {
  "name": "Unica One",
  "category": "display",
  "value": "'Unica One', sans-serif"
}, {
  "name": "UnifrakturCook",
  "category": "display",
  "value": "'UnifrakturCook', sans-serif"
}, {
  "name": "UnifrakturMaguntia",
  "category": "display",
  "value": "'UnifrakturMaguntia', sans-serif"
}, {
  "name": "Unkempt",
  "category": "display",
  "value": "'Unkempt', sans-serif"
}, {
  "name": "Unlock",
  "category": "display",
  "value": "'Unlock', sans-serif"
}, {
  "name": "Unna",
  "category": "serif",
  "value": "'Unna', serif"
}, {
  "name": "Urbanist",
  "category": "sans-serif",
  "value": "'Urbanist', sans-serif"
}, {
  "name": "Vampiro One",
  "category": "display",
  "value": "'Vampiro One', sans-serif"
}, {
  "name": "Varela",
  "category": "sans-serif",
  "value": "'Varela', sans-serif"
}, {
  "name": "Varela Round",
  "category": "sans-serif",
  "value": "'Varela Round', sans-serif"
}, {
  "name": "Varta",
  "category": "sans-serif",
  "value": "'Varta', sans-serif"
}, {
  "name": "Vast Shadow",
  "category": "display",
  "value": "'Vast Shadow', sans-serif"
}, {
  "name": "Vesper Libre",
  "category": "serif",
  "value": "'Vesper Libre', serif"
}, {
  "name": "Viaoda Libre",
  "category": "display",
  "value": "'Viaoda Libre', sans-serif"
}, {
  "name": "Vibes",
  "category": "display",
  "value": "'Vibes', sans-serif"
}, {
  "name": "Vibur",
  "category": "handwriting",
  "value": "'Vibur', cursive"
}, {
  "name": "Vidaloka",
  "category": "serif",
  "value": "'Vidaloka', serif"
}, {
  "name": "Viga",
  "category": "sans-serif",
  "value": "'Viga', sans-serif"
}, {
  "name": "Voces",
  "category": "display",
  "value": "'Voces', sans-serif"
}, {
  "name": "Volkhov",
  "category": "serif",
  "value": "'Volkhov', serif"
}, {
  "name": "Vollkorn",
  "category": "serif",
  "value": "'Vollkorn', serif"
}, {
  "name": "Vollkorn SC",
  "category": "serif",
  "value": "'Vollkorn SC', serif"
}, {
  "name": "Voltaire",
  "category": "sans-serif",
  "value": "'Voltaire', sans-serif"
}, {
  "name": "VT323",
  "category": "monospace",
  "value": "'VT323', monospace"
}, {
  "name": "Waiting for the Sunrise",
  "category": "handwriting",
  "value": "'Waiting for the Sunrise', cursive"
}, {
  "name": "Wallpoet",
  "category": "display",
  "value": "'Wallpoet', sans-serif"
}, {
  "name": "Walter Turncoat",
  "category": "handwriting",
  "value": "'Walter Turncoat', cursive"
}, {
  "name": "Warnes",
  "category": "display",
  "value": "'Warnes', sans-serif"
}, {
  "name": "Wellfleet",
  "category": "display",
  "value": "'Wellfleet', sans-serif"
}, {
  "name": "Wendy One",
  "category": "sans-serif",
  "value": "'Wendy One', sans-serif"
}, {
  "name": "WindSong",
  "category": "handwriting",
  "value": "'WindSong', cursive"
}, {
  "name": "Wire One",
  "category": "sans-serif",
  "value": "'Wire One', sans-serif"
}, {
  "name": "Work Sans",
  "category": "sans-serif",
  "value": "'Work Sans', sans-serif"
}, {
  "name": "Xanh Mono",
  "category": "monospace",
  "value": "'Xanh Mono', monospace"
}, {
  "name": "Yaldevi",
  "category": "sans-serif",
  "value": "'Yaldevi', sans-serif"
}, {
  "name": "Yanone Kaffeesatz",
  "category": "sans-serif",
  "value": "'Yanone Kaffeesatz', sans-serif"
}, {
  "name": "Yantramanav",
  "category": "sans-serif",
  "value": "'Yantramanav', sans-serif"
}, {
  "name": "Yatra One",
  "category": "display",
  "value": "'Yatra One', sans-serif"
}, {
  "name": "Yellowtail",
  "category": "handwriting",
  "value": "'Yellowtail', cursive"
}, {
  "name": "Yeon Sung",
  "category": "display",
  "value": "'Yeon Sung', sans-serif"
}, {
  "name": "Yeseva One",
  "category": "display",
  "value": "'Yeseva One', sans-serif"
}, {
  "name": "Yesteryear",
  "category": "handwriting",
  "value": "'Yesteryear', cursive"
}, {
  "name": "Yomogi",
  "category": "handwriting",
  "value": "'Yomogi', cursive"
}, {
  "name": "Yrsa",
  "category": "serif",
  "value": "'Yrsa', serif"
}, {
  "name": "Yusei Magic",
  "category": "sans-serif",
  "value": "'Yusei Magic', sans-serif"
}, {
  "name": "ZCOOL KuaiLe",
  "category": "display",
  "value": "'ZCOOL KuaiLe', sans-serif"
}, {
  "name": "ZCOOL QingKe HuangYou",
  "category": "display",
  "value": "'ZCOOL QingKe HuangYou', sans-serif"
}, {
  "name": "ZCOOL XiaoWei",
  "category": "serif",
  "value": "'ZCOOL XiaoWei', serif"
}, {
  "name": "Zen Antique",
  "category": "serif",
  "value": "'Zen Antique', serif"
}, {
  "name": "Zen Antique Soft",
  "category": "serif",
  "value": "'Zen Antique Soft', serif"
}, {
  "name": "Zen Dots",
  "category": "display",
  "value": "'Zen Dots', sans-serif"
}, {
  "name": "Zen Kaku Gothic Antique",
  "category": "sans-serif",
  "value": "'Zen Kaku Gothic Antique', sans-serif"
}, {
  "name": "Zen Kaku Gothic New",
  "category": "sans-serif",
  "value": "'Zen Kaku Gothic New', sans-serif"
}, {
  "name": "Zen Kurenaido",
  "category": "sans-serif",
  "value": "'Zen Kurenaido', sans-serif"
}, {
  "name": "Zen Loop",
  "category": "display",
  "value": "'Zen Loop', sans-serif"
}, {
  "name": "Zen Maru Gothic",
  "category": "sans-serif",
  "value": "'Zen Maru Gothic', sans-serif"
}, {
  "name": "Zen Old Mincho",
  "category": "serif",
  "value": "'Zen Old Mincho', serif"
}, {
  "name": "Zen Tokyo Zoo",
  "category": "display",
  "value": "'Zen Tokyo Zoo', sans-serif"
}, {
  "name": "Zeyada",
  "category": "handwriting",
  "value": "'Zeyada', cursive"
}, {
  "name": "Zhi Mang Xing",
  "category": "handwriting",
  "value": "'Zhi Mang Xing', cursive"
}, {
  "name": "Zilla Slab",
  "category": "serif",
  "value": "'Zilla Slab', serif"
}, {
  "name": "Zilla Slab Highlight",
  "category": "display",
  "value": "'Zilla Slab Highlight', sans-serif"
}];
export function getGoogleFontCssValue(fontName) {
  var found = GOOGLE_FONTS_CATALOG.find(function (f) {
    return f.name === fontName;
  });
  return found ? found.value : "'" + fontName + "', sans-serif";
}